import { SvgIcon, SxProps, Theme, useTheme } from '@mui/material';
import React, { ReactNode } from 'react';
import { isDarkMode } from '../../theme';

export function EditButtonIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7.20093 4.26167L7.7376 4.79833L2.4526 10.0833H1.91593V9.54667L7.20093 4.26167ZM9.30093 0.75C9.1551 0.75 9.00343 0.808333 8.8926 0.919167L7.8251 1.98667L10.0126 4.17417L11.0801 3.10667C11.3076 2.87917 11.3076 2.51167 11.0801 2.28417L9.7151 0.919167C9.59843 0.8025 9.4526 0.75 9.30093 0.75ZM7.20093 2.61083L0.749268 9.0625V11.25H2.93677L9.38843 4.79833L7.20093 2.61083Z" />
      </svg>
    </SvgIcon>
  );
}

export function EmergencyOutlinedIcon({ color }: { color?: string }) {
  return (
    <SvgIcon>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.29 13.9L18 12L21.29 10.1C21.77 9.82 21.93 9.21 21.66 8.73L19.66 5.27C19.38 4.79 18.77 4.63 18.29 4.9L15 6.8V3C15 2.45 14.55 2 14 2H9.99999C9.44999 2 8.99999 2.45 8.99999 3V6.8L5.71 4.9C5.23 4.63 4.62 4.79 4.34 5.27L2.33999 8.73C2.05999 9.21 2.22999 9.82 2.70999 10.1L5.99999 12L2.70999 13.9C2.22999 14.18 2.06999 14.79 2.33999 15.27L4.34 18.73C4.62 19.21 5.23 19.37 5.71 19.1L8.99999 17.2V21C8.99999 21.55 9.44999 22 9.99999 22H14C14.55 22 15 21.55 15 21V17.2L18.29 19.1C18.77 19.38 19.38 19.21 19.66 18.73L21.66 15.27C21.94 14.79 21.77 14.18 21.29 13.9ZM18.43 16.87L13.75 14.17C13.42 13.97 13 14.21 13 14.6V20H11V14.6C11 14.22 10.58 13.97 10.25 14.17L5.57 16.87L4.57 15.14L9.24999 12.44C9.57999 12.25 9.57999 11.77 9.24999 11.57L4.57 8.87L5.57 7.14L10.25 9.84C10.58 10.03 11 9.79 11 9.4V4H13V9.4C13 9.78 13.42 10.03 13.75 9.83L18.43 7.13L19.43 8.86L14.75 11.56C14.42 11.75 14.42 12.23 14.75 12.43L19.43 15.13L18.43 16.87Z"
          fill={color ?? 'black'}
        />
      </svg>
    </SvgIcon>
  );
}

export function DashboardIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM5 19V5H11V19H5ZM19 19H13V12H19V19ZM19 10H13V5H19V10Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function SuppliersIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 8H17V4H3C1.9 4 1 4.9 1 6V17H3C3 18.66 4.34 20 6 20C7.66 20 9 18.66 9 17H15C15 18.66 16.34 20 18 20C19.66 20 21 18.66 21 17H23V12L20 8ZM19.5 9.5L21.46 12H17V9.5H19.5ZM6 18C5.45 18 5 17.55 5 17C5 16.45 5.45 16 6 16C6.55 16 7 16.45 7 17C7 17.55 6.55 18 6 18ZM8.22 15C7.67 14.39 6.89 14 6 14C5.11 14 4.33 14.39 3.78 15H3V6H15V15H8.22ZM18 18C17.45 18 17 17.55 17 17C17 16.45 17.45 16 18 16C18.55 16 19 16.45 19 17C19 17.55 18.55 18 18 18Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function ThreatsIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 6.5L15.56 7.05C15.14 7.57 14.58 7.8 14.02 7.8C13 7.8 12 7.02 12 5.8V2.5C12 2.5 4 6.5 4 13.5C4 17.92 7.58 21.5 12 21.5C16.42 21.5 20 17.92 20 13.5C20 10.54 18.39 7.88 16 6.5ZM12 19.5C10.9 19.5 10 18.63 10 17.56C10 17.05 10.2 16.57 10.58 16.2L12 14.8L13.43 16.2C13.8 16.57 14 17.05 14 17.56C14 18.63 13.1 19.5 12 19.5ZM15.96 18C16 17.64 16.18 16.11 14.83 14.78L12 12L9.17 14.78C7.81 16.12 8 17.66 8.04 18C6.79 16.9 6 15.29 6 13.5C6 10.34 8.13 7.85 10.03 6.25C10.26 8.24 11.96 9.8 14.02 9.8C14.8 9.8 15.56 9.57 16.2 9.14C17.34 10.28 18 11.85 18 13.5C18 15.29 17.21 16.9 15.96 18Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function EnablingServicesIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 22H21V15H18V11H13V9H16V2H8V9H11V11H6V15H3V22H11V15H8V13H16V15H13V22ZM10 7V4H14V7H10ZM9 17V20H5V17H9ZM19 17V20H15V17H19Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function RisksIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 6.49L19.53 19.5H4.47L12 6.49ZM12 2.5L1 21.5H23L12 2.5ZM13 16.5H11V18.5H13V16.5ZM13 10.5H11V14.5H13V10.5Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function KpiIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.3642 8.55108L19.1342 10.4011C19.7274 11.5842 20.0178 12.8959 19.9794 14.2188C19.941 15.5417 19.575 16.8344 18.9142 17.9811H5.05418C4.19535 16.4912 3.83948 14.7642 4.03932 13.0561C4.23917 11.3481 4.98409 9.7499 6.16366 8.49851C7.34323 7.24711 8.89465 6.40912 10.5879 6.10877C12.2812 5.80843 14.0262 6.06171 15.5642 6.83108L17.4142 5.60108C15.5307 4.39329 13.2965 3.85208 11.0691 4.06401C8.84163 4.27595 6.74963 5.22878 5.12767 6.77009C3.50572 8.31141 2.44754 10.3521 2.1224 12.5659C1.79725 14.7796 2.22393 17.0385 3.33418 18.9811C3.50869 19.2834 3.75927 19.5347 4.06101 19.7101C4.36275 19.8856 4.70515 19.979 5.05418 19.9811H18.9042C19.2566 19.9825 19.6031 19.8907 19.9087 19.7151C20.2142 19.5395 20.468 19.2863 20.6442 18.9811C21.5656 17.385 22.0279 15.5653 21.9803 13.723C21.9327 11.8807 21.3768 10.0874 20.3742 8.54108L20.3642 8.55108Z"
          fill="currentColor"
        />
        <path
          d="M10.5742 15.3911C10.7599 15.577 10.9805 15.7245 11.2233 15.8252C11.4661 15.9258 11.7264 15.9777 11.9892 15.9777C12.252 15.9777 12.5123 15.9258 12.7551 15.8252C12.9979 15.7245 13.2184 15.577 13.4042 15.3911L19.0642 6.90108L10.5742 12.5611C10.3882 12.7468 10.2407 12.9674 10.1401 13.2102C10.0394 13.453 9.98761 13.7132 9.98761 13.9761C9.98761 14.2389 10.0394 14.4992 10.1401 14.742C10.2407 14.9848 10.3882 15.2053 10.5742 15.3911Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function EventIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM19 8H5V6H19V8ZM12 13H17V18H12V13Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function CampaignIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM9 4H11V9L10 8.25L9 9V4ZM18 20H6V4H7V13L10 10.75L13 13V4H18V20Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function CardRemoveIcon({
  sx,
  strokeColor = '#DCDCE6',
  fillColor = '#5A5B69'
}: {
  sx?: SxProps<Theme>;
  strokeColor?: string;
  fillColor?: string;
}) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V20C23.5 21.933 21.933 23.5 20 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4Z"
          stroke={strokeColor}
        />
        <path d="M17.8333 12.8327H6.16666V11.166H17.8333V12.8327Z" fill={fillColor} />
      </svg>
    </SvgIcon>
  );
}

export function CardAddIcon({
  sx,
  strokeColor = '#DCDCE6',
  fillColor = '#5A5B69'
}: {
  sx?: SxProps<Theme>;
  strokeColor?: string;
  fillColor?: string;
}) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V20C23.5 21.933 21.933 23.5 20 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4Z"
          stroke={strokeColor}
        />
        <path
          d="M17.8333 12.8327H12.8333V17.8327H11.1667V12.8327H6.16667V11.166H11.1667V6.16602H12.8333V11.166H17.8333V12.8327Z"
          fill={fillColor}
        />
      </svg>
    </SvgIcon>
  );
}
export function SettingsIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 17V19H9V17H3ZM3 5V7H13V5H3ZM13 21V19H21V17H13V15H11V21H13ZM7 9V11H3V13H7V15H9V9H7ZM21 13V11H11V13H21ZM15 9H17V7H21V5H17V3H15V9Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function BankIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.1913 2.01842C11.9783 1.97693 11.7585 1.97693 11.5456 2.01842C11.2907 2.06809 11.0659 2.19033 10.9307 2.26381L10.8862 2.28793L2.02125 7.12197C1.61991 7.34082 1.41806 7.80398 1.53099 8.24695C1.64392 8.68992 2.04286 8.99992 2.5 8.99992H21.5C21.9594 8.99992 22.3597 8.6869 22.4705 8.24104C22.5813 7.79518 22.374 7.3312 21.968 7.1162L12.8443 2.28448L12.8422 2.28336L12.8061 2.26381C12.671 2.19032 12.4462 2.06809 12.1913 2.01842ZM11.8684 4.03061L11.8405 4.04555L6.42264 6.99992H17.475L11.8996 4.0473L11.8684 4.03061ZM8 9.91036C8.55228 9.91036 9 10.3581 9 10.9104V18.9104C9 19.4626 8.55228 19.9104 8 19.9104C7.44772 19.9104 7 19.4626 7 18.9104V10.9104C7 10.3581 7.44772 9.91036 8 9.91036ZM12 9.91036C12.5523 9.91036 13 10.3581 13 10.9104V18.9104C13 19.4626 12.5523 19.9104 12 19.9104C11.4477 19.9104 11 19.4626 11 18.9104V10.9104C11 10.3581 11.4477 9.91036 12 9.91036ZM16 9.91036C16.5523 9.91036 17 10.3581 17 10.9104V18.9104C17 19.4626 16.5523 19.9104 16 19.9104C15.4477 19.9104 15 19.4626 15 18.9104V10.9104C15 10.3581 15.4477 9.91036 16 9.91036ZM20 9.91036C20.5523 9.91036 21 10.3581 21 10.9104V18.9104C21 19.4626 20.5523 19.9104 20 19.9104C19.4477 19.9104 19 19.4626 19 18.9104V10.9104C19 10.3581 19.4477 9.91036 20 9.91036ZM1 21.9104C1 21.3581 1.44772 20.9104 2 20.9104H22C22.5523 20.9104 23 21.3581 23 21.9104C23 22.4626 22.5523 22.9104 22 22.9104H2C1.44772 22.9104 1 22.4626 1 21.9104ZM4 9.91036C4.55228 9.91036 5 10.3581 5 10.9104V18.9104C5 19.4626 4.55228 19.9104 4 19.9104C3.44772 19.9104 3 19.4626 3 18.9104V10.9104C3 10.3581 3.44772 9.91036 4 9.91036Z"
          fill="#13121B"
        />
      </svg>
    </SvgIcon>
  );
}

export function BuildingIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 2H13V22H15V19C15 18.45 15.45 18 16 18C16.55 18 17 18.45 17 19V22H19V2C20.1 2 21 2.9 21 4V22H23V24H1V22H3V12C3 10.9 3.9 10 5 10V22H7V19C7 18.45 7.45 18 8 18C8.55 18 9 18.45 9 19V22H11V10H5C5 8.9 5.9 8 7 8H11V3C11 1.34 12.34 0 14 0H17C18.1 0 19 0.9 19 2Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function CreditCardIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Credit Card">
          <g id="Union">
            <path
              d="M7.5 13.3125C6.98223 13.3125 6.5625 13.7322 6.5625 14.25C6.5625 14.7678 6.98223 15.1875 7.5 15.1875H10.5C11.0178 15.1875 11.4375 14.7678 11.4375 14.25C11.4375 13.7322 11.0178 13.3125 10.5 13.3125H7.5Z"
              fill="#13121B"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.25 4.5C3.59315 4.5 2.25 5.84315 2.25 7.5V16.5C2.25 18.1569 3.59315 19.5 5.25 19.5H18.75C20.4069 19.5 21.75 18.1569 21.75 16.5V7.5C21.75 5.84315 20.4069 4.5 18.75 4.5H5.25ZM18.75 6.375H5.25C4.62868 6.375 4.125 6.87868 4.125 7.5V8.25H19.875V7.5C19.875 6.87868 19.3713 6.375 18.75 6.375ZM4.125 16.5V11.25H19.875V16.5C19.875 17.1213 19.3713 17.625 18.75 17.625H5.25C4.62868 17.625 4.125 17.1213 4.125 16.5Z"
              fill="#13121B"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}

export function LinkIcon({
  sx,
  strokeColor = '#DCDCE6',
  fillColor = '#5A5B69'
}: {
  sx?: SxProps<Theme>;
  strokeColor?: string;
  fillColor?: string;
}) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V20C23.5 21.933 21.933 23.5 20 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4Z"
          stroke={strokeColor}
        />
        <path
          d="M4.5 4.5V11.1667H11.1667V4.5H4.5ZM9.5 9.5H6.16667V6.16667H9.5V9.5ZM4.5 12.8333V19.5H11.1667V12.8333H4.5ZM9.5 17.8333H6.16667V14.5H9.5V17.8333ZM12.8333 4.5V11.1667H19.5V4.5H12.8333ZM17.8333 9.5H14.5V6.16667H17.8333V9.5ZM12.8333 12.8333V19.5H19.5V12.8333H12.8333ZM17.8333 17.8333H14.5V14.5H17.8333V17.8333Z"
          fill={fillColor}
        />
      </svg>
    </SvgIcon>
  );
}

export function CalendarCheckIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="38"
        height="39"
        viewBox="0 0 38 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="calendar-check">
          <path
            id="Vector"
            d="M26.125 8.41667V5.25M11.875 8.41667V5.25M5.14583 13.1667H32.8542M16.2421 23.0496L17.8792 24.9206C18.0294 25.0921 18.3001 25.0795 18.4335 24.8947L21.7579 20.2917M19 33.75C12.2825 33.75 8.92373 33.75 6.83686 31.6631C4.75 29.5763 4.75 26.2175 4.75 19.5C4.75 12.7825 4.75 11.0071 6.83686 8.9202C8.92373 6.83333 12.2825 6.83333 19 6.83333C25.7175 6.83333 29.0763 6.83333 31.1631 8.9202C33.25 11.0071 33.25 12.7825 33.25 19.5C33.25 26.2175 33.25 29.5763 31.1631 31.6631C29.0763 33.75 25.7175 33.75 19 33.75Z"
            stroke="#90909D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}

export function TwoFoldersIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.9999 7H11.6612C11.1745 7 10.7045 6.82252 10.3392 6.50083L8.06671 4.49917M18.9999 7C20.1045 7 20.9999 7.89543 20.9999 9V18C20.9999 19.1046 20.1045 20 18.9999 20H5C3.89543 20 3 19.1046 3 18V6C3 4.89543 3.89543 4 5 4H6.74477C7.23147 4 7.70148 4.17748 8.06671 4.49917M18.9999 7C18.9999 5.61883 17.8803 4.49917 16.4991 4.49917H8.06671"
          stroke="#90909D"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}

export function InitialFolderIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.5 8C6.5 9.10457 7.39543 10 8.5 10C9.60457 10 10.5 9.10457 10.5 8C10.5 6.89543 9.60457 6 8.5 6C7.39543 6 6.5 6.89543 6.5 8Z"
          fill="#90909D"
        />
        <path
          d="M3 12C3 7.75736 3 5.63604 4.31802 4.31802C5.63604 3 7.75736 3 12 3C16.2426 3 18.364 3 19.682 4.31802C21 5.63604 21 7.75736 21 12C21 16.2426 21 18.364 19.682 19.682C18.364 21 16.2426 21 12 21C7.75736 21 5.63604 21 4.31802 19.682C3 18.364 3 16.2426 3 12Z"
          fill="#90909D"
        />
        <path
          d="M20.9273 9.98979C14.3161 9.08222 8.61609 13.9902 8.99998 20.5M3 13.0656C5.77936 12.6808 8.27485 14.0245 9.62356 16.1659M6.5 8C6.5 9.10457 7.39543 10 8.5 10C9.60457 10 10.5 9.10457 10.5 8C10.5 6.89543 9.60457 6 8.5 6C7.39543 6 6.5 6.89543 6.5 8ZM12 21C7.75736 21 5.63604 21 4.31802 19.682C3 18.364 3 16.2426 3 12C3 7.75736 3 5.63604 4.31802 4.31802C5.63604 3 7.75736 3 12 3C16.2426 3 18.364 3 19.682 4.31802C21 5.63604 21 7.75736 21 12C21 16.2426 21 18.364 19.682 19.682C18.364 21 16.2426 21 12 21Z"
          stroke="#90909D"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}

export function CreditVisaCardIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Visa">
          <path
            id="Vector"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.50019 15.1717H4.59624L3.16851 9.5646C3.10075 9.30668 2.95686 9.07866 2.74521 8.97119C2.217 8.70111 1.63496 8.48618 1 8.37777V8.1619H4.06711C4.49042 8.1619 4.8079 8.48618 4.86081 8.86278L5.6016 12.9073L7.50462 8.1619H9.35565L6.50019 15.1717ZM10.4138 15.1717H8.61572L10.0964 8.1619H11.8945L10.4138 15.1717ZM14.2209 10.1036C14.2739 9.72604 14.5913 9.51017 14.9617 9.51017C15.5438 9.45597 16.1778 9.56437 16.7069 9.83351L17.0244 8.32428C16.4953 8.1084 15.9132 8 15.385 8C13.6398 8 12.3699 8.97096 12.3699 10.3185C12.3699 11.3437 13.2694 11.882 13.9044 12.2062C14.5913 12.5296 14.8559 12.7454 14.803 13.0688C14.803 13.5538 14.2739 13.7697 13.7456 13.7697C13.1107 13.7697 12.4757 13.608 11.8946 13.3379L11.5771 14.8481C12.2121 15.1172 12.899 15.2256 13.534 15.2256C15.4909 15.2789 16.7069 14.3089 16.7069 12.8529C16.7069 11.0194 14.2209 10.9119 14.2209 10.1036ZM22.9999 15.1717L21.5722 8.1619H20.0387C19.7212 8.1619 19.4037 8.37777 19.2979 8.70111L16.6541 15.1717H18.5051L18.8746 14.1474H21.1489L21.3606 15.1717H22.9999ZM20.303 10.0491L20.8312 12.691H19.3506L20.303 10.0491Z"
            fill="#13121B"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}

export function ExpandMoreIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="expand_more">
          <path
            id="Vector"
            d="M14.6468 16.4476L15 16.8L15.3532 16.4476L20.7371 11.0754L21.7929 12.1312L15 18.924L8.20711 12.1312L9.26289 11.0754L14.6468 16.4476Z"
            fill="black"
            stroke="#90909D"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}

export function FolderIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 21H21C21 22.11 20.1 23 19 23H4C2.34 23 1 21.66 1 20V9C1 7.9 1.9 7 3 7V21ZM23 5V19C23 20.1 22.1 21 21 21V7H3C3 5.9 3.9 5 5 5H10V4C10 2.35 11.35 1 13 1H20C21.65 1 23 2.35 23 4V5ZM21 5V3H12V5H21Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function UserIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 13.75C6.66 13.75 2 14.92 2 17.25V19H16V17.25C16 14.92 11.34 13.75 9 13.75ZM4.34 17C5.18 16.42 7.21 15.75 9 15.75C10.79 15.75 12.82 16.42 13.66 17H4.34ZM9 12C10.93 12 12.5 10.43 12.5 8.5C12.5 6.57 10.93 5 9 5C7.07 5 5.5 6.57 5.5 8.5C5.5 10.43 7.07 12 9 12ZM9 7C9.83 7 10.5 7.67 10.5 8.5C10.5 9.33 9.83 10 9 10C8.17 10 7.5 9.33 7.5 8.5C7.5 7.67 8.17 7 9 7ZM16.04 13.81C17.2 14.65 18 15.77 18 17.25V19H22V17.25C22 15.23 18.5 14.08 16.04 13.81ZM15 12C16.93 12 18.5 10.43 18.5 8.5C18.5 6.57 16.93 5 15 5C14.46 5 13.96 5.13 13.5 5.35C14.13 6.24 14.5 7.33 14.5 8.5C14.5 9.67 14.13 10.76 13.5 11.65C13.96 11.87 14.46 12 15 12Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}
interface UserCircleDefaultIconProps {
  sx?: SxProps<Theme>;
  strokeColor?: string;
}

export function UserCircleDefaultIcon({
  sx,
  strokeColor = isDarkMode() ? '#FFFFFF' : '#000000'
}: UserCircleDefaultIconProps) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="user-circle">
          <ellipse
            id="Vector"
            cx="8.00065"
            cy="6.06669"
            rx="1.66667"
            ry="1.66667"
            stroke={strokeColor}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            id="Vector_2"
            cx="8"
            cy="8"
            r="6"
            stroke={strokeColor}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_3"
            d="M11.3327 12.8C11.1214 8.67554 4.8773 8.67554 4.66602 12.8"
            stroke={strokeColor}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}

export function UnionIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="26"
        viewBox="0 0 24 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.95641 1.14067C11.2063 0.35757 12.7937 0.357572 14.0436 1.14067L23.4688 7.046C23.8102 7.25991 24.0122 7.63914 23.9992 8.04181C23.9972 8.10318 23.9903 8.16368 23.9787 8.22283C23.9926 8.29353 23.9998 8.36659 23.9998 8.44134V18.382C24.007 18.7786 23.8051 19.1672 23.4382 19.3813L13.9394 24.9222C12.741 25.6213 11.259 25.6213 10.0606 24.9222L0.561831 19.3813C0.19486 19.1672 -0.006978 18.7786 0.000184307 18.382V8.44134C0.000184307 8.36659 0.00742899 8.29353 0.0212545 8.22283C0.00967901 8.16368 0.00275196 8.10318 0.000772697 8.04181C-0.0122146 7.63914 0.189782 7.25991 0.531187 7.046L9.95641 1.14067ZM13.1321 14.5504L21.7357 9.9034V17.7532L13.1321 22.772V14.5504ZM10.868 14.5504L2.2643 9.9034V17.7532L10.868 22.772V14.5504ZM12.8415 3.0593C12.3268 2.73685 11.6732 2.73685 11.1585 3.0593L3.38013 7.93282L12 12.5886L20.6199 7.93282L12.8415 3.0593Z"
          fill="#13121B"
        />
      </svg>
    </SvgIcon>
  );
}

export function ListIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 3H23V5H9V3ZM7 4C7 2.35 5.65 1 4 1C2.35 1 1 2.35 1 4C1 5.65 2.35 7 4 7C5.65 7 7 5.65 7 4ZM5 4C5 4.55 4.55 5 4 5C3.45 5 3 4.55 3 4C3 3.45 3.45 3 4 3C4.55 3 5 3.45 5 4ZM9 13H23V11H9V13ZM7 12C7 10.35 5.65 9 4 9C2.35 9 1 10.35 1 12C1 13.65 2.35 15 4 15C5.65 15 7 13.65 7 12ZM5 12C5 12.55 4.55 13 4 13C3.45 13 3 12.55 3 12C3 11.45 3.45 11 4 11C4.55 11 5 11.45 5 12ZM9 21H23V19H9V21ZM7 20C7 18.35 5.65 17 4 17C2.35 17 1 18.35 1 20C1 21.65 2.35 23 4 23C5.65 23 7 21.65 7 20ZM5 20C5 20.55 4.55 21 4 21C3.45 21 3 20.55 3 20C3 19.45 3.45 19 4 19C4.55 19 5 19.45 5 20Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function LayersIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 9V20C16 21.66 14.66 23 13 23H4C2.9 23 2 22.1 2 21H14V11H2V21C0.9 21 0 20.11 0 19V12C0 10.34 1.34 9 3 9H16ZM18 18.82C19.16 18.41 20 17.31 20 16V5H7C5.7 5 4.6 5.84 4.18 7H18V18.82ZM22 3C22 1.9 21.1 1 20 1H11C9.7 1 8.6 1.84 8.18 3H22ZM22 14.82C23.16 14.41 24 13.31 24 12V5C24 3.9 23.1 3 22 3V14.82Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function AssetsIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 2H4C2.9 2 2 2.9 2 4V14H4V4H14V2ZM18 6H8C6.9 6 6 6.9 6 8V18H8V8H18V6ZM20 10H12C10.9 10 10 10.9 10 12V20C10 21.1 10.9 22 12 22H20C21.1 22 22 21.1 22 20V12C22 10.9 21.1 10 20 10ZM20 20H12V12H20V20Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function CompareIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 5V19H9V21H3C1.34 21 0 19.66 0 18V7C0 5.9 0.9 5 2 5ZM21 3H12V1H10V23H12V21H20C21.1 21 22 20.11 22 19H12V5H22V19C23.1 19 24 18.1 24 17V6C24 4.34 22.66 3 21 3ZM2 5H9V3H4C2.9 3 2 3.9 2 5Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function FileIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 8.41C22 7.88 21.79 7.37 21.41 7L15 0.59C14.62 0.21 14.12 0 13.59 0H5C3.34 0 2 1.34 2 3V20C2 21.1 2.89 22 4 22V2H12V6C12 7.1 12.9 8 14 8V2.41L19.59 8H14C14 9.1 14.9 10 16 10H20V22H4C4 23.1 4.9 24 6 24H19C20.66 24 22 22.66 22 21V8.41Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function FilterIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 3L23 3V5L13 5V3ZM11 4C11 2.35 9.64999 1 7.99999 1C6.34999 1 5 2.35 5 4C5 5.65 6.34999 7 7.99999 7C9.64999 7 11 5.65 11 4ZM8.99999 4C8.99999 4.55 8.54999 5 7.99999 5C7.44999 5 7 4.55 7 4C7 3.45 7.44999 3 7.99999 3C8.54999 3 8.99999 3.45 8.99999 4ZM18.5 12C18.5 10.35 17.15 9 15.5 9C13.85 9 12.5 10.35 12.5 12C12.5 13.65 13.85 15 15.5 15C17.15 15 18.5 13.65 18.5 12ZM16.5 12C16.5 12.55 16.05 13 15.5 13C14.95 13 14.5 12.55 14.5 12C14.5 11.45 14.95 11 15.5 11C16.05 11 16.5 11.45 16.5 12ZM16 21H23V19H16V21ZM14 20C14 18.35 12.65 17 11 17C9.35 17 8.00001 18.35 8.00001 20C8.00001 21.65 9.35 23 11 23C12.65 23 14 21.65 14 20ZM12 20C12 20.55 11.55 21 11 21C10.45 21 10 20.55 10 20C10 19.45 10.45 19 11 19C11.55 19 12 19.45 12 20Z"
          fill="currentColor"
        />
        <path d="M10.5 13L1 13L1 11L10.5 11V13Z" fill="currentColor" />
        <path d="M23 13H20.5L20.5 11H23L23 13Z" fill="currentColor" />
        <path d="M3 3L1 3L1 5H3L3 3Z" fill="currentColor" />
        <path d="M6 19H1L1 21H6L6 19Z" fill="currentColor" />
      </svg>
    </SvgIcon>
  );
}

export function FileUpload({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5003 10V12H4.50033V10H3.16699V12C3.16699 12.7334 3.76699 13.3334 4.50033 13.3334H12.5003C13.2337 13.3334 13.8337 12.7334 13.8337 12V10H12.5003ZM5.16699 6.00002L6.10699 6.94002L7.83366 5.22002V10.6667H9.16699V5.22002L10.8937 6.94002L11.8337 6.00002L8.50033 2.66669L5.16699 6.00002Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function FileUploadOutlined({ sx }: { sx?: SxProps<Theme> }): ReactNode {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill={isDarkMode() ? '#FFFFFF' : '#000000'}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 16.5H15V10.5H19L12 3.5L5 10.5H9V16.5ZM12 6.33L14.17 8.5H13V14.5H11V8.5H9.83L12 6.33ZM5 18.5H19V20.5H5V18.5Z"
          fill={isDarkMode() ? '#FFFFFF' : '#000000'}
        />
      </svg>
    </SvgIcon>
  );
}

export function FileDownloadOutlined({ sx }: { sx?: SxProps<Theme> }): ReactNode {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill={isDarkMode() ? '#FFFFFF' : '#000000'}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 9.5H15V3.5H9V9.5H5L12 16.5L19 9.5ZM11 11.5V5.5H13V11.5H14.17L12 13.67L9.83 11.5H11ZM5 18.5H19V20.5H5V18.5Z"
          fill={isDarkMode() ? '#FFFFFF' : '#000000'}
        />
      </svg>
    </SvgIcon>
  );
}

export function ArrowBack({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.3337 7.33335H5.22033L8.94699 3.60669L8.00033 2.66669L2.66699 8.00002L8.00033 13.3334L8.94033 12.3934L5.22033 8.66669H13.3337V7.33335Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function LearnMoreIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.91667 3.75V5.41667H13.4083L3.75 15.075L4.925 16.25L14.5833 6.59167V12.0833H16.25V3.75H7.91667Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function JourneyIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="33"
        height="32"
        viewBox="0 0 33 32"
        fill="none"
      >
        <path
          d="M5.83301 9.33331C3.63301 9.33331 1.83301 7.53331 1.83301 5.33331C1.83301 3.13331 3.63301 1.33331 5.83301 1.33331C8.03301 1.33331 9.83301 3.13331 9.83301 5.33331C9.83301 7.53331 8.03301 9.33331 5.83301 9.33331ZM5.83301 3.99998C5.09967 3.99998 4.49967 4.59998 4.49967 5.33331C4.49967 6.06665 5.09967 6.66665 5.83301 6.66665C6.56634 6.66665 7.16634 6.06665 7.16634 5.33331C7.16634 4.59998 6.56634 3.99998 5.83301 3.99998ZM27.1663 30.6666C24.9663 30.6666 23.1663 28.8666 23.1663 26.6666C23.1663 24.4666 24.9663 22.6666 27.1663 22.6666C29.3663 22.6666 31.1663 24.4666 31.1663 26.6666C31.1663 28.8666 29.3663 30.6666 27.1663 30.6666ZM27.1663 25.3333C26.433 25.3333 25.833 25.9333 25.833 26.6666C25.833 27.4 26.433 28 27.1663 28C27.8997 28 28.4997 27.4 28.4997 26.6666C28.4997 25.9333 27.8997 25.3333 27.1663 25.3333ZM25.833 3.99998C27.2997 3.99998 28.4997 5.19998 28.4997 6.66665H11.1663V3.99998H25.833ZM4.49967 17.3333V25.3333C3.03301 25.3333 1.83301 24.1333 1.83301 22.6666V18.6666C1.83301 16.4666 3.63301 14.6666 5.83301 14.6666H28.4997V6.66665C29.9663 6.66665 31.1663 7.86665 31.1663 9.33331V13.3333C31.1663 15.5333 29.3663 17.3333 27.1663 17.3333H4.49967ZM7.16634 28C5.69967 28 4.49967 26.8 4.49967 25.3333H21.833V28H7.16634Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function InfoIconContained({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM6.67 6.63V6.97L7.29 7.11L6.61 10.21C6.57667 10.3633 6.55 10.5033 6.53 10.63C6.51 10.7567 6.5 10.8867 6.5 11.02C6.5 11.1333 6.54667 11.24 6.64 11.34C6.74 11.4333 6.91667 11.48 7.17 11.48C7.29 11.48 7.41667 11.4667 7.55 11.44C7.68333 11.42 7.81333 11.39 7.94 11.35C8.07333 11.31 8.19667 11.2633 8.31 11.21C8.43 11.1567 8.53333 11.1 8.62 11.04V10.7H7.92L8.82 6.39L8.64 6.27C8.5 6.27 8.33667 6.28333 8.15 6.31C7.97 6.33 7.78667 6.35667 7.6 6.39C7.41333 6.42333 7.23667 6.46333 7.07 6.51C6.90333 6.55 6.77 6.59 6.67 6.63ZM7.74 4.19C7.58667 4.31667 7.51 4.49333 7.51 4.72C7.51 4.93333 7.58667 5.10333 7.74 5.23C7.89333 5.35667 8.08667 5.42 8.32 5.42C8.57333 5.42 8.77333 5.35667 8.92 5.23C9.07333 5.10333 9.15 4.93333 9.15 4.72C9.15 4.49333 9.07333 4.31667 8.92 4.19C8.77333 4.06333 8.57333 4 8.32 4C8.08667 4 7.89333 4.06333 7.74 4.19Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function PdfIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM16 12V9C16 8.45 15.55 8 15 8H13V13H15C15.55 13 16 12.55 16 12ZM14 9H15V12H14V9ZM18 11H19V10H18V9H19V8H17V13H18V11ZM10 11H11C11.55 11 12 10.55 12 10V9C12 8.45 11.55 8 11 8H9V13H10V11ZM10 9H11V10H10V9Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function PeopleAltIcon({ sx, color }: { sx?: SxProps<Theme>; color?: string }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill={color ?? 'black'}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.67 13.13C18.04 14.06 19 15.32 19 17V20H23V17C23 14.82 19.43 13.53 16.67 13.13Z"
          fill={color ?? 'black'}
        />
        <path
          d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C14.53 4 14.09 4.1 13.67 4.24C14.5 5.27 15 6.58 15 8C15 9.42 14.5 10.73 13.67 11.76C14.09 11.9 14.53 12 15 12Z"
          fill={color ?? 'black'}
        />
        <path
          d="M9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12ZM9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6Z"
          fill={color ?? 'black'}
        />
        <path
          d="M9 13C6.33 13 1 14.34 1 17V20H17V17C17 14.34 11.67 13 9 13ZM15 18H3V17.01C3.2 16.29 6.3 15 9 15C11.7 15 14.8 16.29 15 17V18Z"
          fill={color ?? 'black'}
        />
      </svg>
    </SvgIcon>
  );
}

export function OpenInNewIcon({ sx, onClick }: { sx?: SxProps<Theme>; onClick?: () => void }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        onClick={onClick}
      >
        <path
          d="M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z"
          fill="#5A5A69"
        />
      </svg>
    </SvgIcon>
  );
}

export function FilterTableIcon({ sx, onClick }: { sx?: any; onClick?: () => void }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        onClick={onClick}
      >
        <path
          d="M4.66996 4H11.3366L7.99663 8.2L4.66996 4ZM2.83663 3.74C4.18329 5.46667 6.66996 8.66667 6.66996 8.66667V12.6667C6.66996 13.0333 6.96996 13.3333 7.33663 13.3333H8.66996C9.03663 13.3333 9.33663 13.0333 9.33663 12.6667V8.66667C9.33663 8.66667 11.8166 5.46667 13.1633 3.74C13.5033 3.3 13.19 2.66667 12.6366 2.66667H3.36329C2.80996 2.66667 2.49663 3.3 2.83663 3.74Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function DoneIcon({ sx, onClick }: { sx?: any; onClick?: () => void }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        onClick={onClick}
      >
        <path
          d="M5.86645 10.6031L3.53312 8.26977C3.27312 8.00977 2.85979 8.00977 2.59979 8.26977C2.33979 8.52977 2.33979 8.94311 2.59979 9.20311L5.39312 11.9964C5.65312 12.2564 6.07312 12.2564 6.33312 11.9964L13.3998 4.93644C13.6598 4.67644 13.6598 4.26311 13.3998 4.00311C13.1398 3.74311 12.7265 3.74311 12.4665 4.00311L5.86645 10.6031Z"
          fill="black"
        />
      </svg>
    </SvgIcon>
  );
}

export function FilledCircleTickIcon({ sx }: { sx?: any }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <g clipPath="url(#clip0_544_10298)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM23.6393 9.72266C24.6807 10.7641 24.6807 12.4525 23.6393 13.4939L16.0956 21.0376L14.21 19.1519L23.6393 9.72266ZM6.66667 17.2663L8.55228 15.3807L15.1519 21.9804C14.1105 23.0218 12.4221 23.0218 11.3807 21.9804L6.66667 17.2663Z"
            fill="#3CDC85"
          />
        </g>
        <defs>
          <clipPath id="clip0_544_10298">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function BulbIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bulb" clipPath="url(#clip0_3519_570)">
        <path
          id="Vector"
          d="M16 22C16 23.1 15.1 24 14 24H10C8.9 24 8 23.1 8 22H16ZM18 17V19V20C18 21.1 17.1 22 16 22V19H8V22C6.9 22 6 21.1 6 20V17H7V15.54C7 14.77 6.72 14.06 6.22 13.53C4.42 11.64 3.66 9.06997 4.14 6.47997C4.73 3.30997 7.25 0.769965 10.41 0.149965C12.8 -0.320035 15.24 0.289965 17.09 1.81997C18.94 3.34997 20 5.59997 20 7.99997C20 10.1 19.19 12.08 17.73 13.58C17.27 14.05 17 14.77 17 15.54V17H18ZM16.3 12.18C17.4 11.05 18 9.56997 18 7.99997C18 6.19997 17.2 4.50997 15.81 3.36997C14.42 2.22997 12.59 1.76997 10.78 2.11997C8.42 2.57997 6.54 4.47997 6.1 6.83997C5.74 8.79996 6.3 10.73 7.66 12.14C8.52 13.04 8.99 14.24 8.99 15.53V16.99H10.99V10.99H12.99V16.99H14.99V15.53C14.99 14.22 15.45 13.03 16.29 12.17L16.3 12.18Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3519_570">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function PDFIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM16 12V9C16 8.45 15.55 8 15 8H13V13H15C15.55 13 16 12.55 16 12ZM14 9H15V12H14V9ZM18 11H19V10H18V9H19V8H17V13H18V11ZM10 11H11C11.55 11 12 10.55 12 10V9C12 8.45 11.55 8 11 8H9V13H10V11ZM10 9H11V10H10V9Z"
        fill="#90909D"
      />
    </svg>
  );
}

export function FlagIcon() {
  return (
    <SvgIcon>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M13.5 5.5L12.5 3.5H4.5V20.5H6.5V13.5H11.5L12.5 15.5H19.5V5.5H13.5ZM17.5 13.5H13.5L12.5 11.5H6.5V5.5H11.5L12.5 7.5H17.5V13.5Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function DarkModeLogo({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="98"
        height="36"
        viewBox="0 0 98 36"
        fill="none"
      >
        <g clipPath="url(#clip0_2145_3337)">
          <path
            d="M8.07583 7.56763C10.5324 7.56763 12.4822 8.1038 13.9408 9.17614C15.3993 10.2485 16.1209 11.9183 16.1209 14.2161V23.4229C16.1209 24.0357 15.9828 24.4953 15.7064 24.8323C15.384 25.2 15.0002 25.5217 14.5703 25.7668C13.7258 26.2264 12.8353 26.5634 11.9141 26.7932C10.6859 27.0995 9.41156 27.2527 8.15259 27.2221C5.58859 27.2221 3.59267 26.7166 2.14946 25.7208C0.721604 24.7098 0 23.2391 0 21.2936C0 19.5625 0.568071 18.2298 1.68886 17.2953C2.80965 16.3761 4.4371 15.8093 6.5405 15.5949L12.0523 15.0434V14.1702C12.0523 13.0059 11.6685 12.1634 10.9162 11.6425C10.1639 11.1217 9.11985 10.8459 7.76876 10.8459C6.74009 10.8459 5.71142 10.9838 4.71346 11.2749C3.82297 11.5353 2.94783 11.8723 2.1034 12.2706C1.84239 12.0561 1.61209 11.7957 1.42786 11.5046C1.24362 11.1983 1.13614 10.8459 1.1515 10.4936C1.13614 10.0953 1.25897 9.71231 1.48927 9.39061C1.76563 9.05358 2.13411 8.79316 2.53329 8.63997C3.33166 8.25699 4.19145 7.98124 5.06658 7.82805C6.06455 7.64422 7.07786 7.56763 8.07583 7.56763ZM8.15259 23.9744C8.96632 23.9898 9.78004 23.8978 10.5631 23.6987C11.254 23.5149 11.7453 23.3157 12.037 23.1012V18.0766L7.7227 18.5055C6.50979 18.6434 5.58859 18.9038 4.98982 19.3174C4.39104 19.731 4.08397 20.3591 4.08397 21.2017C4.08397 22.0749 4.40639 22.7489 5.06658 23.2391C5.72677 23.7293 6.75544 23.9744 8.15259 23.9744Z"
            fill="#1ABC9C"
          />
          <path
            d="M28.2961 23.423C29.9543 23.423 31.1825 23.0553 31.9809 22.3047C32.7793 21.5694 33.1784 20.6043 33.1784 19.44C33.1784 18.4136 32.8714 17.5864 32.2726 16.9583C31.6738 16.3302 30.7066 15.794 29.3862 15.3804L26.4076 14.4C25.5325 14.1089 24.7034 13.7413 23.8897 13.3123C23.1835 12.9294 22.5233 12.4391 21.9705 11.857C21.4332 11.2902 21.0186 10.6315 20.7423 9.89617C20.4506 9.05362 20.3124 8.16511 20.3277 7.26128C20.3277 5.00936 21.0954 3.24766 22.6461 1.94553C24.1968 0.643404 26.2848 0 28.9409 0C29.9543 0 30.9676 0.0919149 31.9655 0.275745C32.7946 0.428936 33.593 0.689362 34.3606 1.0417C34.9594 1.31745 35.4968 1.71574 35.942 2.19064C36.3105 2.57362 36.5101 3.09447 36.5101 3.61532C36.5255 4.05957 36.4026 4.50383 36.1723 4.87149C35.9574 5.20851 35.681 5.51489 35.3586 5.74468C34.5756 5.13192 33.7005 4.67234 32.7639 4.35064C31.6278 3.95234 30.4302 3.75319 29.2173 3.76851C27.7587 3.76851 26.6379 4.07489 25.8549 4.70298C25.0719 5.30043 24.6267 6.23489 24.6727 7.23064C24.6727 8.08851 24.9491 8.77787 25.5018 9.29872C26.0545 9.81957 26.9604 10.2945 28.2347 10.6928L30.5377 11.4128C32.7639 12.1328 34.4835 13.0979 35.7117 14.3387C36.94 15.5796 37.5541 17.2647 37.5541 19.394C37.5695 20.4664 37.3545 21.5387 36.94 22.5345C36.5408 23.4689 35.942 24.3115 35.1744 24.9855C34.3453 25.7055 33.3627 26.2417 32.3033 26.5634C31.0443 26.9464 29.724 27.1302 28.4036 27.1149C27.2828 27.1302 26.162 27.023 25.0566 26.7932C24.1507 26.6094 23.2909 26.303 22.4619 25.8894C21.817 25.583 21.2336 25.154 20.773 24.6026C20.4045 24.1736 20.1896 23.6374 20.1742 23.0706C20.1589 22.5498 20.3277 22.0289 20.6502 21.6153C20.9419 21.2323 21.3257 20.926 21.7556 20.7115C22.5233 21.4315 23.3984 22.0443 24.3503 22.5038C25.4557 23.1319 26.7761 23.423 28.2961 23.423Z"
            fill="white"
          />
          <path
            d="M41.6995 2.60419C41.6842 1.94547 41.9452 1.31738 42.4058 0.873126C42.8971 0.398233 43.5573 0.153127 44.2328 0.168446C44.893 0.137807 45.5532 0.398233 46.0138 0.873126C46.9196 1.85355 46.9196 3.35483 46.0138 4.35057C45.5686 4.81015 44.9698 5.05525 44.2328 5.05525C43.5573 5.08589 42.8971 4.82547 42.4058 4.35057C41.9452 3.891 41.6842 3.26291 41.6995 2.60419ZM46.2902 26.7931C46.0445 26.885 45.7835 26.9616 45.5225 27.0076C45.154 27.0842 44.7702 27.1148 44.3863 27.0995C43.6187 27.0995 43.0506 26.9463 42.6821 26.6553C42.3137 26.3642 42.1294 25.874 42.1141 25.1846V8.31823L42.9278 8.11908C43.2963 8.04249 43.6801 7.99653 44.0639 7.99653C44.8316 7.99653 45.3997 8.14972 45.7528 8.44079C46.1059 8.73185 46.2902 9.23738 46.2902 9.95738V26.7931Z"
            fill="white"
          />
          <path
            d="M63.7775 25.966C63.2095 26.3183 62.58 26.5941 61.9351 26.7779C61.0907 27.0077 60.2156 27.1302 59.3404 27.0996C58.2196 27.0996 57.0988 26.9311 56.0241 26.5941C54.9954 26.257 54.0589 25.7055 53.2759 24.9549C52.4315 24.1277 51.7866 23.1319 51.3874 22.029C50.9268 20.8341 50.6965 19.3481 50.6965 17.6017C50.6965 16.0238 50.9268 14.6298 51.3874 13.4502C51.802 12.3319 52.4775 11.3056 53.3373 10.463C54.1817 9.65108 55.195 9.023 56.3158 8.64002C57.5441 8.21108 58.8338 8.01193 60.1388 8.02725C61.3517 8.01193 62.5646 8.19576 63.7315 8.53279C64.6834 8.80853 65.5739 9.20683 66.4029 9.743C66.8175 10.0187 67.1706 10.3558 67.447 10.7694C67.708 11.183 67.8308 11.6732 67.8308 12.1634V28.2945C67.8308 29.6579 67.6005 30.8375 67.1399 31.8179C66.71 32.7524 66.0652 33.5796 65.2361 34.2077C64.3763 34.8511 63.4091 35.3107 62.365 35.5558C61.1982 35.8468 60.0006 36 58.8031 35.9847C57.6209 36 56.454 35.8621 55.3025 35.5711C54.3199 35.2953 53.6137 35.0196 53.1684 34.7439C52.3547 34.223 51.9401 33.5336 51.9401 32.6911C51.9094 31.9251 52.2779 31.1898 52.9381 30.7609C53.6904 31.2664 54.5041 31.6647 55.3639 31.9558C56.3926 32.3081 57.4827 32.4919 58.5728 32.4919C60.2309 32.4919 61.5206 32.1396 62.4418 31.4502C63.3476 30.7609 63.8082 29.6273 63.8082 28.0647L63.7775 25.966ZM59.9392 23.76C60.7069 23.7907 61.4899 23.6375 62.1961 23.3464C62.7642 23.1013 63.2709 22.7643 63.7315 22.366V12.4545C63.2709 12.1787 62.7796 11.949 62.2729 11.7804C61.6127 11.566 60.9065 11.4587 60.2156 11.4741C58.6035 11.4741 57.3138 11.9796 56.3312 12.9907C55.3486 14.0017 54.8573 15.5336 54.8726 17.5711C54.8573 18.5362 54.9801 19.5166 55.2718 20.4358C55.4868 21.1404 55.8552 21.7992 56.3465 22.366C56.7764 22.8562 57.3291 23.2085 57.9586 23.423C58.5728 23.6528 59.2637 23.76 59.9392 23.76Z"
            fill="white"
          />
          <path
            d="M84.0746 12.286C83.353 11.6886 82.3704 11.3822 81.1267 11.3822C80.2823 11.3669 79.4532 11.4894 78.6549 11.7345C78.01 11.9337 77.3805 12.1941 76.7664 12.5158V26.8086C76.5208 26.9005 76.2598 26.9771 75.9987 27.0231C75.6456 27.0843 75.2771 27.1303 74.9087 27.115C74.141 27.115 73.5729 26.9771 73.2044 26.686C72.836 26.395 72.6517 25.9201 72.6517 25.246V12.3933C72.6517 11.7958 72.7746 11.3209 73.0049 10.9533C73.3273 10.509 73.7265 10.1414 74.2024 9.86561C75.1083 9.34476 76.0909 8.94646 77.0888 8.6554C78.3939 8.27242 79.7603 8.08859 81.1267 8.10391C83.6907 8.10391 85.6867 8.67072 87.1452 9.80434C88.6038 10.938 89.3254 12.6384 89.31 14.9209V26.8086C89.049 26.9005 88.788 26.9771 88.5117 27.0231C88.1432 27.0843 87.7747 27.1303 87.4062 27.115C86.6386 27.115 86.0705 26.9771 85.702 26.686C85.3335 26.395 85.1493 25.9201 85.1493 25.246V15.0894C85.1647 13.818 84.7962 12.8835 84.0746 12.286Z"
            fill="white"
          />
          <path
            d="M92.7645 24.5259C92.7338 23.8213 92.9948 23.1472 93.4554 22.6264C93.916 22.1208 94.5609 21.8757 95.3746 21.8757C96.219 21.8757 96.8639 22.1208 97.3245 22.6264C98.2149 23.7293 98.2149 25.3225 97.3245 26.4255C96.8792 26.9311 96.2344 27.1762 95.3746 27.1762C94.5609 27.1762 93.916 26.9311 93.4554 26.4255C92.9948 25.9047 92.7492 25.2306 92.7645 24.5259Z"
            fill="#1ABC9C"
          />
        </g>
        <defs>
          <clipPath id="clip0_2145_3337">
            <rect width="98" height="36" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function LightModeLogo({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="98"
        height="36"
        viewBox="0 0 98 36"
        fill="none"
      >
        <g clipPath="url(#clip0_2170_1568)">
          <path
            d="M8.07583 7.56763C10.5324 7.56763 12.4822 8.1038 13.9408 9.17614C15.3993 10.2485 16.1209 11.9183 16.1209 14.2161V23.4229C16.1209 24.0357 15.9828 24.4953 15.7064 24.8323C15.384 25.2 15.0002 25.5217 14.5703 25.7668C13.7258 26.2264 12.8353 26.5634 11.9141 26.7932C10.6859 27.0995 9.41156 27.2527 8.15259 27.2221C5.5886 27.2221 3.59267 26.7166 2.14946 25.7208C0.721604 24.7098 0 23.2391 0 21.2936C0 19.5625 0.568071 18.2298 1.68886 17.2953C2.80965 16.3761 4.4371 15.8093 6.5405 15.5949L12.0523 15.0434V14.1702C12.0523 13.0059 11.6685 12.1634 10.9162 11.6425C10.1639 11.1217 9.11985 10.8459 7.76876 10.8459C6.74009 10.8459 5.71142 10.9838 4.71346 11.2749C3.82297 11.5353 2.94783 11.8723 2.1034 12.2706C1.84239 12.0561 1.61209 11.7957 1.42786 11.5046C1.24362 11.1983 1.13614 10.8459 1.1515 10.4936C1.13614 10.0953 1.25897 9.71231 1.48927 9.39061C1.76563 9.05358 2.13411 8.79316 2.53329 8.63997C3.33166 8.25699 4.19145 7.98124 5.06658 7.82805C6.06455 7.64422 7.07786 7.56763 8.07583 7.56763ZM8.15259 23.9744C8.96632 23.9898 9.78004 23.8978 10.5631 23.6987C11.254 23.5149 11.7453 23.3157 12.037 23.1012V18.0766L7.7227 18.5055C6.50979 18.6434 5.5886 18.9038 4.98982 19.3174C4.39104 19.731 4.08397 20.3591 4.08397 21.2017C4.08397 22.0749 4.40639 22.7489 5.06658 23.2391C5.72677 23.7293 6.75544 23.9744 8.15259 23.9744Z"
            fill="#1ABC9C"
          />
          <path
            d="M28.2961 23.423C29.9543 23.423 31.1825 23.0553 31.9809 22.3047C32.7793 21.5694 33.1784 20.6043 33.1784 19.44C33.1784 18.4136 32.8714 17.5864 32.2726 16.9583C31.6738 16.3302 30.7066 15.794 29.3862 15.3804L26.4076 14.4C25.5325 14.1089 24.7034 13.7413 23.8897 13.3123C23.1835 12.9294 22.5233 12.4391 21.9705 11.857C21.4332 11.2902 21.0186 10.6315 20.7423 9.89617C20.4506 9.05362 20.3124 8.16511 20.3277 7.26128C20.3277 5.00936 21.0954 3.24766 22.6461 1.94553C24.1968 0.643404 26.2848 0 28.9409 0C29.9543 0 30.9676 0.0919149 31.9655 0.275745C32.7946 0.428936 33.593 0.689362 34.3606 1.0417C34.9594 1.31745 35.4968 1.71574 35.942 2.19064C36.3105 2.57362 36.5101 3.09447 36.5101 3.61532C36.5255 4.05957 36.4026 4.50383 36.1723 4.87149C35.9574 5.20851 35.681 5.51489 35.3586 5.74468C34.5756 5.13192 33.7005 4.67234 32.7639 4.35064C31.6278 3.95234 30.4302 3.75319 29.2173 3.76851C27.7587 3.76851 26.6379 4.07489 25.8549 4.70298C25.0719 5.30043 24.6267 6.23489 24.6727 7.23064C24.6727 8.08851 24.9491 8.77787 25.5018 9.29872C26.0545 9.81957 26.9604 10.2945 28.2347 10.6928L30.5377 11.4128C32.7639 12.1328 34.4835 13.0979 35.7117 14.3387C36.94 15.5796 37.5541 17.2647 37.5541 19.394C37.5695 20.4664 37.3545 21.5387 36.94 22.5345C36.5408 23.4689 35.942 24.3115 35.1744 24.9855C34.3453 25.7055 33.3627 26.2417 32.3033 26.5634C31.0443 26.9464 29.724 27.1302 28.4036 27.1149C27.2828 27.1302 26.162 27.023 25.0566 26.7932C24.1507 26.6094 23.2909 26.303 22.4619 25.8894C21.817 25.583 21.2336 25.154 20.773 24.6026C20.4045 24.1736 20.1896 23.6374 20.1742 23.0706C20.1589 22.5498 20.3277 22.0289 20.6502 21.6153C20.9419 21.2323 21.3257 20.926 21.7556 20.7115C22.5233 21.4315 23.3984 22.0443 24.3503 22.5038C25.4557 23.1319 26.7761 23.423 28.2961 23.423Z"
            fill="#222222"
          />
          <path
            d="M41.6995 2.60419C41.6842 1.94547 41.9452 1.31738 42.4058 0.873126C42.8971 0.398233 43.5573 0.153127 44.2328 0.168446C44.893 0.137807 45.5532 0.398233 46.0138 0.873126C46.9196 1.85355 46.9196 3.35483 46.0138 4.35057C45.5686 4.81015 44.9698 5.05525 44.2328 5.05525C43.5573 5.08589 42.8971 4.82547 42.4058 4.35057C41.9452 3.891 41.6842 3.26291 41.6995 2.60419ZM46.2902 26.7931C46.0445 26.885 45.7835 26.9616 45.5225 27.0076C45.154 27.0842 44.7702 27.1148 44.3863 27.0995C43.6187 27.0995 43.0506 26.9463 42.6821 26.6553C42.3137 26.3642 42.1294 25.874 42.1141 25.1846V8.31823L42.9278 8.11908C43.2963 8.04249 43.6801 7.99653 44.0639 7.99653C44.8316 7.99653 45.3997 8.14972 45.7528 8.44079C46.1059 8.73185 46.2902 9.23738 46.2902 9.95738V26.7931Z"
            fill="#222222"
          />
          <path
            d="M63.7775 25.966C63.2095 26.3183 62.58 26.5941 61.9351 26.7779C61.0907 27.0077 60.2156 27.1302 59.3404 27.0996C58.2196 27.0996 57.0988 26.9311 56.0241 26.5941C54.9954 26.257 54.0589 25.7055 53.2759 24.9549C52.4315 24.1277 51.7866 23.1319 51.3874 22.029C50.9268 20.8341 50.6965 19.3481 50.6965 17.6017C50.6965 16.0238 50.9268 14.6298 51.3874 13.4502C51.802 12.3319 52.4775 11.3056 53.3373 10.463C54.1817 9.65108 55.195 9.023 56.3158 8.64002C57.5441 8.21108 58.8338 8.01193 60.1388 8.02725C61.3517 8.01193 62.5646 8.19576 63.7315 8.53279C64.6834 8.80853 65.5739 9.20683 66.4029 9.743C66.8175 10.0187 67.1706 10.3558 67.447 10.7694C67.708 11.183 67.8308 11.6732 67.8308 12.1634V28.2945C67.8308 29.6579 67.6005 30.8375 67.1399 31.8179C66.71 32.7524 66.0652 33.5796 65.2361 34.2077C64.3763 34.8511 63.4091 35.3107 62.365 35.5558C61.1982 35.8468 60.0006 36 58.8031 35.9847C57.6209 36 56.454 35.8621 55.3025 35.5711C54.3199 35.2953 53.6137 35.0196 53.1684 34.7439C52.3547 34.223 51.9401 33.5336 51.9401 32.6911C51.9094 31.9251 52.2779 31.1898 52.9381 30.7609C53.6904 31.2664 54.5041 31.6647 55.3639 31.9558C56.3926 32.3081 57.4827 32.4919 58.5728 32.4919C60.2309 32.4919 61.5206 32.1396 62.4418 31.4502C63.3476 30.7609 63.8082 29.6273 63.8082 28.0647L63.7775 25.966ZM59.9392 23.76C60.7069 23.7907 61.4899 23.6375 62.1961 23.3464C62.7642 23.1013 63.2709 22.7643 63.7315 22.366V12.4545C63.2709 12.1787 62.7796 11.949 62.2729 11.7804C61.6127 11.566 60.9065 11.4587 60.2156 11.4741C58.6035 11.4741 57.3138 11.9796 56.3312 12.9907C55.3486 14.0017 54.8573 15.5336 54.8726 17.5711C54.8573 18.5362 54.9801 19.5166 55.2718 20.4358C55.4868 21.1404 55.8552 21.7992 56.3465 22.366C56.7764 22.8562 57.3291 23.2085 57.9586 23.423C58.5728 23.6528 59.2637 23.76 59.9392 23.76Z"
            fill="#222222"
          />
          <path
            d="M84.0746 12.2859C83.353 11.6885 82.3704 11.3821 81.1267 11.3821C80.2823 11.3668 79.4532 11.4893 78.6549 11.7344C78.01 11.9336 77.3805 12.194 76.7664 12.5157V26.8085C76.5208 26.9004 76.2598 26.977 75.9987 27.0229C75.6456 27.0842 75.2771 27.1302 74.9087 27.1149C74.141 27.1149 73.5729 26.977 73.2044 26.6859C72.836 26.3949 72.6517 25.92 72.6517 25.2459V12.3932C72.6517 11.7957 72.7746 11.3208 73.0049 10.9532C73.3273 10.5089 73.7265 10.1412 74.2024 9.86549C75.1083 9.34464 76.0909 8.94634 77.0888 8.65528C78.3939 8.2723 79.7603 8.08847 81.1267 8.10379C83.6907 8.10379 85.6867 8.6706 87.1452 9.80421C88.6038 10.9378 89.3254 12.6383 89.31 14.9208V26.8085C89.049 26.9004 88.788 26.977 88.5117 27.0229C88.1432 27.0842 87.7747 27.1302 87.4062 27.1149C86.6386 27.1149 86.0705 26.977 85.702 26.6859C85.3335 26.3949 85.1493 25.92 85.1493 25.2459V15.0893C85.1647 13.8178 84.7962 12.8834 84.0746 12.2859Z"
            fill="#222222"
          />
          <path
            d="M92.7645 24.5259C92.7338 23.8213 92.9948 23.1472 93.4554 22.6264C93.916 22.1208 94.5609 21.8757 95.3746 21.8757C96.219 21.8757 96.8639 22.1208 97.3245 22.6264C98.2149 23.7293 98.2149 25.3225 97.3245 26.4255C96.8792 26.9311 96.2344 27.1762 95.3746 27.1762C94.5609 27.1762 93.916 26.9311 93.4554 26.4255C92.9948 25.9047 92.7492 25.2306 92.7645 24.5259Z"
            fill="#1ABC9C"
          />
        </g>
        <defs>
          <clipPath id="clip0_2170_1568">
            <rect width="98" height="36" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function RemoveIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path d="M15.8334 10.8337H4.16669V9.16699H15.8334V10.8337Z" fill="#90909D" />
      </svg>
    </SvgIcon>
  );
}

export function AddIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M15.8333 10.8337H10.8333V15.8337H9.16663V10.8337H4.16663V9.16699H9.16663V4.16699H10.8333V9.16699H15.8333V10.8337Z"
          fill="#90909D"
        />
      </svg>
    </SvgIcon>
  );
}

export function GasIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24 15C19.2 15 15 18.86 15 24C15 26.12 15.74 28.07 16.97 29.61L15 31.59L16.41 33L18.38 31.03C19.93 32.26 21.88 33 24 33C26.3 33 28.61 32.12 30.36 30.36C32.12 28.61 33 26.3 33 24V15H24ZM31 24C31 25.87 30.27 27.63 28.95 28.95C27.63 30.27 25.87 31 24 31C20.14 31 17 27.86 17 24C17 22.1 17.74 20.32 19.1 19.01C20.42 17.71 22.16 17 24 17H31V24Z"
          fill="black"
        />
        <path
          d="M20.46 24.63L24.51 25.03L22.07 28.36C21.96 28.52 21.97 28.74 22.11 28.88C22.26 29.03 22.51 29.04 22.67 28.89L27.83 24.26C28.16 23.96 27.98 23.41 27.53 23.37L23.48 22.97L25.92 19.64C26.03 19.48 26.02 19.26 25.88 19.12C25.73 18.97 25.48 18.96 25.32 19.11L20.16 23.74C19.84 24.04 20.02 24.59 20.46 24.63Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function WaterIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.35 24.5C18.54 24.5 18.77 25.5 20.68 25.5C22.63 25.5 22.77 24.5 24.01 24.5C25.2 24.5 25.43 25.5 27.34 25.5C29.29 25.5 29.43 24.5 30.67 24.5C31.86 24.5 32.07 25.48 33.98 25.5V23.5C32.79 23.5 32.56 22.5 30.65 22.5C28.7 22.5 28.56 23.5 27.32 23.5C26.13 23.5 25.9 22.5 23.99 22.5C22.04 22.5 21.9 23.5 20.66 23.5C19.47 23.5 19.24 22.5 17.33 22.5C15.38 22.5 15.24 23.5 14 23.5V25.5C15.9 25.5 16.17 24.5 17.35 24.5ZM30.67 27.5C28.72 27.5 28.58 28.5 27.34 28.5C26.15 28.5 25.92 27.5 24.01 27.5C22.06 27.5 21.91 28.5 20.67 28.5C19.43 28.5 19.29 27.5 17.34 27.5C15.39 27.5 15.24 28.5 14 28.5V30.5C15.95 30.5 16.11 29.5 17.34 29.5C18.58 29.5 18.72 30.5 20.67 30.5C22.62 30.5 22.77 29.5 24.01 29.5C25.2 29.5 25.43 30.5 27.34 30.5C29.28 30.5 29.43 29.5 30.67 29.5C31.86 29.5 32.09 30.5 34 30.5V28.5C32.76 28.5 32.62 27.5 30.67 27.5ZM17.35 19.5C18.54 19.5 18.77 20.5 20.68 20.5C22.63 20.5 22.77 19.5 24.01 19.5C25.2 19.5 25.43 20.5 27.34 20.5C29.29 20.5 29.43 19.5 30.67 19.5C31.86 19.5 32.07 20.48 33.98 20.5V18.5C32.79 18.5 32.56 17.5 30.65 17.5C28.7 17.5 28.56 18.5 27.32 18.5C26.13 18.5 25.9 17.5 23.99 17.5C22.04 17.5 21.9 18.5 20.66 18.5C19.47 18.5 19.24 17.5 17.33 17.5C15.38 17.5 15.24 18.5 14 18.5V20.5C15.9 20.5 16.17 19.5 17.35 19.5Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function WasteIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_5044_9099)">
          <path
            d="M18 34H30L31 21H33L32 33C32 34.66 30.66 36 29 36H20C18.9 36 18 35.1 18 34ZM15 15V18H13V20H35V18H33V16C33 14.9 32.11 14 31 14V18H17V14H31C31 12.9 30.1 12 29 12H18C16.34 12 15 13.34 15 15ZM18 34L17 21H15L16 32C16 33.1 16.9 34 18 34Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_5044_9099">
            <rect width="24" height="24" fill="white" transform="translate(12 12)" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function EditIcon({ sx, color }: { sx?: SxProps<Theme>; color?: string }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M2.99875 17.251V21.001H6.74875L17.8087 9.94103L14.0587 6.19104L2.99875 17.251ZM20.7087 7.04104C21.0987 6.65104 21.0987 6.02104 20.7087 5.63104L18.3687 3.29104C17.9787 2.90104 17.3487 2.90104 16.9587 3.29104L15.1287 5.12104L18.8787 8.87104L20.7087 7.04104Z"
          fill={color ?? 'black'}
        />
      </svg>
    </SvgIcon>
  );
}

export function MoreVertIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z"
          fill="black"
        />
      </svg>
    </SvgIcon>
  );
}

export function MoreAvatarIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <svg width="5" height="20" viewBox="0 0 5 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="MORE">
        <path
          d="M2.75 4.75C1.50736 4.75 0.500001 3.74264 0.500001 2.5C0.500001 1.25736 1.50736 0.25 2.75 0.25C3.99264 0.25 5 1.25736 5 2.5C5 3.74264 3.99264 4.75 2.75 4.75Z"
          fill="#13121B"
        />
        <path
          d="M2.75 12.25C1.50736 12.25 0.5 11.2426 0.5 10C0.5 8.75736 1.50736 7.75 2.75 7.75C3.99264 7.75 5 8.75736 5 10C5 11.2426 3.99264 12.25 2.75 12.25Z"
          fill="#13121B"
        />
        <path
          d="M0.5 17.5C0.5 18.7426 1.50736 19.75 2.75 19.75C3.99264 19.75 5 18.7426 5 17.5C5 16.2574 3.99264 15.25 2.75 15.25C1.50736 15.25 0.5 16.2574 0.5 17.5Z"
          fill="#13121B"
        />
      </g>
    </svg>
  );
}

export function InventoryIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M16.6667 1.6665H3.33333C2.5 1.6665 1.66667 2.4165 1.66667 3.33317V5.8415C1.66667 6.4415 2.025 6.95817 2.5 7.24984V16.6665C2.5 17.5832 3.41667 18.3332 4.16667 18.3332H15.8333C16.5833 18.3332 17.5 17.5832 17.5 16.6665V7.24984C17.975 6.95817 18.3333 6.4415 18.3333 5.8415V3.33317C18.3333 2.4165 17.5 1.6665 16.6667 1.6665ZM15.8333 16.6665H4.16667V7.49984H15.8333V16.6665ZM16.6667 5.83317H3.33333V3.33317H16.6667V5.83317Z"
          fill="#595235"
        />
        <path d="M12.5 9.99984H7.5V11.6665H12.5V9.99984Z" fill="#595235" />
      </svg>
    </SvgIcon>
  );
}

export function SmallBulbIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.99993 11.0001C5.99993 11.5501 5.54993 12.0001 4.99993 12.0001H2.99993C2.44993 12.0001 1.99993 11.5501 1.99993 11.0001H5.99993ZM6.99993 8.5001V9.5001V10.0001C6.99993 10.5501 6.54993 11.0001 5.99993 11.0001V9.5001H1.99993V11.0001C1.44993 11.0001 0.999932 10.5501 0.999932 10.0001V8.5001H1.49993V7.7701C1.49993 7.38511 1.35993 7.0301 1.10993 6.7651C0.209932 5.8201 -0.170068 4.5351 0.0699317 3.2401C0.364932 1.6551 1.62493 0.385105 3.20493 0.0751048C4.39993 -0.159895 5.61993 0.145105 6.54493 0.910105C7.46993 1.6751 7.99993 2.8001 7.99993 4.0001C7.99993 5.05011 7.59493 6.0401 6.86493 6.7901C6.63493 7.0251 6.49993 7.38511 6.49993 7.7701V8.5001H6.99993ZM6.14993 6.09011C6.69993 5.5251 6.99993 4.7851 6.99993 4.0001C6.99993 3.1001 6.59993 2.2551 5.90493 1.6851C5.20993 1.1151 4.29493 0.885105 3.38993 1.0601C2.20993 1.2901 1.26993 2.2401 1.04993 3.4201C0.869932 4.4001 1.14993 5.36511 1.82993 6.07011C2.25993 6.5201 2.49493 7.1201 2.49493 7.7651V8.4951H3.49493V5.4951H4.49493V8.4951H5.49493V7.7651C5.49493 7.1101 5.72493 6.5151 6.14493 6.0851L6.14993 6.09011Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
}

export function DotIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.2625 3.13H0.6025V0.47H3.2625V3.13Z" fill="currentColor" />
      </svg>
    </SvgIcon>
  );
}

export function SearchIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M11.6133 11.6133L11.3282 11.8584C10.4653 12.6002 9.34656 13.0459 8.12916 13.0459C5.41364 13.0459 3.21249 10.8447 3.21249 8.12919C3.21249 5.41367 5.41364 3.21252 8.12916 3.21252C10.8447 3.21252 13.0458 5.41367 13.0458 8.12919C13.0458 9.3466 12.6001 10.4653 11.8583 11.3282L11.6133 11.6133ZM12.3792 12.3792H12.4708H12.9218L16.5807 16.0455L16.0455 16.5808L12.3792 12.9218V12.4709V12.3792ZM3.87916 8.12919C3.87916 10.4803 5.77802 12.3792 8.12916 12.3792C10.4803 12.3792 12.3792 10.4803 12.3792 8.12919C12.3792 5.77805 10.4803 3.87919 8.12916 3.87919C5.77802 3.87919 3.87916 5.77805 3.87916 8.12919Z"
          fill="white"
          stroke="#90909D"
        />
      </svg>
    </SvgIcon>
  );
}

export function SearchPlusIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="search-plus">
          <path
            id="Vector"
            d="M11.2619 11.2797L13.3153 13.3332M12.7227 7.72057C12.7227 10.5119 10.4676 12.7746 7.68569 12.7746C4.90381 12.7746 2.64865 10.5119 2.64865 7.72057C2.64865 4.92929 4.90381 2.6665 7.68569 2.6665C10.4676 2.6665 12.7227 4.92929 12.7227 7.72057Z"
            stroke="#90909D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M6.33334 7.6665H9.00001"
            stroke="#90909D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_3"
            d="M7.66666 6.3335L7.66666 9.00016"
            stroke="#90909D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}

export function BellIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 21.75C13.1 21.75 14 20.85 14 19.75H10C10 20.85 10.9 21.75 12 21.75ZM18 15.75V10.75C18 7.68 16.37 5.11 13.5 4.43V3.75C13.5 2.92 12.83 2.25 12 2.25C11.17 2.25 10.5 2.92 10.5 3.75V4.43C7.64 5.11 6 7.67 6 10.75V15.75L4 17.75V18.75H20V17.75L18 15.75ZM16 16.75H8V10.75C8 8.27 9.51 6.25 12 6.25C14.49 6.25 16 8.27 16 10.75V16.75Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}
export function BellWithBadgeIcon({ sx }: { sx?: SxProps<Theme> }) {
  const theme = useTheme();

  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 21.75C13.1 21.75 14 20.85 14 19.75H10C10 20.85 10.9 21.75 12 21.75ZM18 15.75V10.75C18 7.68 16.37 5.11 13.5 4.43V3.75C13.5 2.92 12.83 2.25 12 2.25C11.17 2.25 10.5 2.92 10.5 3.75V4.43C7.64 5.11 6 7.67 6 10.75V15.75L4 17.75V18.75H20V17.75L18 15.75ZM16 16.75H8V10.75C8 8.27 9.51 6.25 12 6.25C14.49 6.25 16 8.27 16 10.75V16.75Z"
          fill="currentColor"
        />
        <circle cx="18" cy="6" r="4" fill={theme.brandPalette.background.negativeHighlight} />
      </svg>
    </SvgIcon>
  );
}

export function CheckCircleIcon({ sx }: { sx?: SxProps<Theme> }) {
  const theme = useTheme();

  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10 1.66675C5.40001 1.66675 1.66667 5.40008 1.66667 10.0001C1.66667 14.6001 5.40001 18.3334 10 18.3334C14.6 18.3334 18.3333 14.6001 18.3333 10.0001C18.3333 5.40008 14.6 1.66675 10 1.66675ZM10 16.6667C6.32501 16.6667 3.33334 13.6751 3.33334 10.0001C3.33334 6.32508 6.32501 3.33341 10 3.33341C13.675 3.33341 16.6667 6.32508 16.6667 10.0001C16.6667 13.6751 13.675 16.6667 10 16.6667ZM13.825 6.31675L8.33334 11.8084L6.175 9.65842L5.00001 10.8334L8.33334 14.1667L15 7.50008L13.825 6.31675Z"
          fill={theme.brandPalette.foreground.successOffset}
        />
      </svg>
    </SvgIcon>
  );
}

export function CheckCircularAvatarIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="34"
        height="34"
        viewBox="0 0 34 34"
        fill="none"
      >
        <circle cx="17" cy="17" r="16" fill="#0C3CE4" fillOpacity="0.1" stroke="#0C3CE4" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.756 13.2307C24.0769 13.5426 24.0819 14.0532 23.7672 14.3711L15.4648 22.7582C15.3127 22.9119 15.1049 22.9989 14.8877 23C14.6704 23.001 14.4618 22.916 14.3082 22.7638L10.2384 18.7315C9.92053 18.4166 9.92053 17.906 10.2384 17.591C10.5563 17.2761 11.0716 17.2761 11.3895 17.591L14.8781 21.0475L22.6049 13.2418C22.9197 12.9238 23.435 12.9188 23.756 13.2307Z"
          fill="#0C3CE4"
        />
      </svg>
    </SvgIcon>
  );
}

export function CircleUndoneIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="circle undone">
          <circle id="Ellipse 118" cx="12" cy="12" r="8" fill="#3C3C46" />
          <circle id="Ellipse 117" cx="12" cy="12" r="4" fill="#1E1E29" />
        </g>
      </svg>
    </SvgIcon>
  );
}
export function SendCircleIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={{ display: 'flex', ...sx }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="34"
        height="34"
        viewBox="0 0 34 34"
        fill="none"
      >
        <circle cx="17" cy="17" r="16" fill="#F89827" fillOpacity="0.1" stroke="#F89827" />
        <g transform="translate(7, 7)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.9744 4.88736C16.042 4.6442 15.9734 4.3835 15.795 4.20504C15.6165 4.02659 15.3558 3.95801 15.1126 4.02555L2.51267 7.52554C2.25433 7.5973 2.05968 7.81032 2.01144 8.07406C1.96321 8.3378 2.06986 8.60593 2.28607 8.76448L6.87805 12.1319L6.40496 12.605C6.13159 12.8784 6.13159 13.3216 6.40496 13.595C6.67833 13.8683 7.12154 13.8683 7.39491 13.595L7.868 13.1219L11.2355 17.7139C11.3941 17.9301 11.6622 18.0368 11.9259 17.9886C12.1897 17.9403 12.4027 17.7457 12.4745 17.4873L15.9744 4.88736ZM11.5116 15.723L8.86963 12.1203L13.9133 7.07664L11.5116 15.723ZM7.87968 11.1304L12.9234 6.08669L4.27705 8.48844L7.87968 11.1304Z"
            fill="#F89827"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}

export function UserCircleIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={{ display: 'flex', ...sx }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="34"
        height="34"
        viewBox="0 0 34 34"
        fill="none"
      >
        <circle cx="17" cy="17" r="16" fill="#1ABC9C" fillOpacity="0.1" stroke="#1ABC9C" />
        <g transform="translate(7, 7)">
          <path
            d="M10.0001 5.2001C10.8801 5.2001 11.6001 5.9201 11.6001 6.8001C11.6001 7.6801 10.8801 8.4001 10.0001 8.4001C9.1201 8.4001 8.4001 7.6801 8.4001 6.8001C8.4001 5.9201 9.1201 5.2001 10.0001 5.2001ZM10.0001 13.2001C12.1601 13.2001 14.6401 14.2321 14.8001 14.8001H5.2001C5.3841 14.2241 7.8481 13.2001 10.0001 13.2001ZM10.0001 3.6001C8.2321 3.6001 6.8001 5.0321 6.8001 6.8001C6.8001 8.5681 8.2321 10.0001 10.0001 10.0001C11.7681 10.0001 13.2001 8.5681 13.2001 6.8001C13.2001 5.0321 11.7681 3.6001 10.0001 3.6001ZM10.0001 11.6001C7.8641 11.6001 3.6001 12.6721 3.6001 14.8001V16.4001H16.4001V14.8001C16.4001 12.6721 12.1361 11.6001 10.0001 11.6001Z"
            fill="#1ABC9C"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}

export function InsertDriveFileIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.6663 1.66602H4.99967C4.08301 1.66602 3.34134 2.41602 3.34134 3.33268L3.33301 16.666C3.33301 17.5827 4.07467 18.3327 4.99134 18.3327H14.9997C15.9163 18.3327 16.6663 17.5827 16.6663 16.666V6.66602L11.6663 1.66602ZM4.99967 16.666V3.33268H10.833V7.49935H14.9997V16.666H4.99967Z"
          fill="#5A5B69"
        />
      </svg>
    </SvgIcon>
  );
}

export function FactCheckFileIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3ZM20 19H4V5H20V19Z"
          fill="#5A5A69"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.41 10.42L17.99 9L14.82 12.17L13.41 10.75L12 12.16L14.82 15L19.41 10.42Z"
          fill="#5A5A69"
        />
        <path d="M10 7H5V9H10V7Z" fill="#5A5A69" />
        <path d="M10 11H5V13H10V11Z" fill="#5A5A69" />
        <path d="M10 15H5V17H10V15Z" fill="#5A5A69" />
      </svg>
    </SvgIcon>
  );
}

export function MasterCardIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Mastercard">
          <g id="Vector">
            <path
              d="M22.272 12C22.272 15.3137 19.5533 18 16.1997 18C12.8461 18 10.1275 15.3137 10.1275 12C10.1275 8.68629 12.8461 6 16.1997 6C19.5533 6 22.272 8.68629 22.272 12Z"
              fill="#13121B"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.3453 6.34103C9.71247 6.12017 9.03157 6 8.32226 6C4.96864 6 2.25 8.68629 2.25 12C2.25 15.3137 4.96864 18 8.32226 18C9.03157 18 9.71247 17.8798 10.3453 17.659C8.89629 16.2111 7.99999 14.2102 7.99999 12C7.99999 9.78978 8.89629 7.78891 10.3453 6.34103Z"
              fill="#13121B"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}

export function ReportIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M13.1083 2.5H6.89167L2.5 6.89167V13.1083L6.89167 17.5H13.1083L17.5 13.1083V6.89167L13.1083 2.5ZM15.8333 12.4167L12.4167 15.8333H7.58333L4.16667 12.4167V7.58333L7.58333 4.16667H12.4167L15.8333 7.58333V12.4167Z"
          fill="currentColor"
        />
        <path
          d="M10 14.1667C10.4602 14.1667 10.8333 13.7936 10.8333 13.3333C10.8333 12.8731 10.4602 12.5 10 12.5C9.53976 12.5 9.16667 12.8731 9.16667 13.3333C9.16667 13.7936 9.53976 14.1667 10 14.1667Z"
          fill="currentColor"
        />
        <path d="M9.16667 5.83333H10.8333V11.6667H9.16667V5.83333Z" fill="currentColor" />
      </svg>
    </SvgIcon>
  );
}

export function RSSFeedIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M5.33333 16.4842C6.33665 16.4842 7.15 15.6709 7.15 14.6676C7.15 13.6643 6.33665 12.8509 5.33333 12.8509C4.33001 12.8509 3.51666 13.6643 3.51666 14.6676C3.51666 15.6709 4.33001 16.4842 5.33333 16.4842Z"
          fill="currentColor"
        />
        <path
          d="M3.51666 3.51758V5.87591C9.375 5.87591 14.125 10.6259 14.125 16.4842H16.4833C16.4833 9.32591 10.675 3.51758 3.51666 3.51758ZM3.51666 8.23425V10.5926C6.76666 10.5926 9.40833 13.2342 9.40833 16.4842H11.7667C11.7667 11.9259 8.075 8.23425 3.51666 8.23425Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function ATipIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_529_452)">
          <circle cx="15" cy="15" r="13.5" stroke="#3C3C46" strokeWidth="3" />
          <path
            d="M13.2917 8.33337C14.9583 8.33337 16.2812 8.69796 17.2708 9.42712C18.2604 10.1563 18.75 11.2917 18.75 12.8542V19.1146C18.75 19.5313 18.6562 19.8438 18.4688 20.073C18.25 20.323 17.9896 20.5417 17.6979 20.7084C17.125 21.0209 16.5208 21.25 15.8958 21.4063C15.0625 21.6146 14.1979 21.7188 13.3437 21.698C11.6042 21.698 10.25 21.3542 9.27083 20.6771C8.30208 19.9896 7.8125 18.9896 7.8125 17.6667C7.8125 16.4896 8.19792 15.5834 8.95833 14.948C9.71875 14.323 10.8229 13.9375 12.25 13.7917L15.9896 13.4167V12.823C15.9896 12.0313 15.7292 11.4584 15.2187 11.1042C14.7083 10.75 14 10.5625 13.0833 10.5625C12.3854 10.5625 11.6875 10.6563 11.0104 10.8542C10.4062 11.0313 9.8125 11.2605 9.23958 11.5313C9.0625 11.3855 8.90625 11.2084 8.78125 11.0105C8.65625 10.8021 8.58333 10.5625 8.59375 10.323C8.58333 10.0521 8.66667 9.79171 8.82292 9.57296C9.01042 9.34379 9.26042 9.16671 9.53125 9.06254C10.0729 8.80212 10.6562 8.61462 11.25 8.51046C11.9271 8.38546 12.6146 8.33337 13.2917 8.33337ZM13.3437 19.4896C13.8958 19.5 14.4479 19.4375 14.9792 19.3021C15.4479 19.1771 15.7812 19.0417 15.9792 18.8959V15.4792L13.0521 15.7709C12.2292 15.8646 11.6042 16.0417 11.1979 16.323C10.7917 16.6042 10.5833 17.0313 10.5833 17.6042C10.5833 18.198 10.8021 18.6563 11.25 18.9896C11.6979 19.323 12.3958 19.4896 13.3437 19.4896Z"
            fill="#3C3C46"
          />
          <path
            d="M20.0017 19.8646C19.9808 19.3854 20.1579 18.9271 20.4704 18.5729C20.7829 18.2292 21.2204 18.0625 21.7725 18.0625C22.3454 18.0625 22.7829 18.2292 23.0954 18.5729C23.6996 19.3229 23.6996 20.4062 23.0954 21.1562C22.7933 21.5 22.3558 21.6667 21.7725 21.6667C21.2204 21.6667 20.7829 21.5 20.4704 21.1562C20.1579 20.8021 19.9912 20.3438 20.0017 19.8646Z"
            fill="#3C3C46"
          />
        </g>
        <defs>
          <clipPath id="clip0_529_452">
            <rect width="30" height="30" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function FlagEnUKIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1110_4937)">
          <path
            d="M12.0009 24.0019C18.6289 24.0019 24.0019 18.6289 24.0019 12.0009C24.0019 5.373 18.6289 0 12.0009 0C5.373 0 0 5.373 0 12.0009C0 18.6289 5.373 24.0019 12.0009 24.0019Z"
            fill="#00247D"
          />
          <path
            d="M23.5957 15.0999C23.1707 16.6945 22.4261 18.1575 21.4351 19.4173L0.404297 8.90195C0.829275 7.30734 1.57393 5.84436 2.56492 4.58447L23.5957 15.0999Z"
            fill="white"
          />
          <path
            d="M23.5957 8.90195L2.56492 19.4173C1.57393 18.1575 0.827395 16.6926 0.404297 15.0999L21.4351 4.58447C22.4261 5.84436 23.1726 7.30734 23.5957 8.90195Z"
            fill="white"
          />
          <path
            d="M23.3588 15.8784C23.3419 15.9273 23.325 15.9743 23.308 16.0232C23.1444 16.4858 22.9526 16.9333 22.7364 17.3658L14.4136 13.2044V11.4048L23.3588 15.8765V15.8784Z"
            fill="#CF142B"
          />
          <path
            d="M9.58652 10.805V12.6046L0.639404 8.13103C0.656328 8.08026 0.675133 8.0276 0.692056 7.97683C0.855654 7.51801 1.04558 7.07234 1.25995 6.64172L9.58464 10.805H9.58652Z"
            fill="#CF142B"
          />
          <path
            d="M22.7345 6.62853L16.8186 9.58646H13.2195L21.9146 5.23889C22.2174 5.68267 22.4919 6.14714 22.7326 6.63041L22.7345 6.62853Z"
            fill="#CF142B"
          />
          <path
            d="M10.7617 14.4136L2.07971 18.7536C1.77696 18.3098 1.50429 17.8454 1.26172 17.3621L7.16065 14.4117H10.7598L10.7617 14.4136Z"
            fill="#CF142B"
          />
          <path
            d="M16.0232 0.692V23.3099C14.7652 23.7574 13.4113 24.0019 11.9991 24.0019C10.5869 24.0019 9.23299 23.7574 7.97498 23.3099V0.692C9.23487 0.244457 10.5888 0 12.001 0C13.4132 0 14.7671 0.244457 16.0251 0.692H16.0232Z"
            fill="white"
          />
          <path
            d="M24 12.0009C24 13.0728 23.859 14.1108 23.5957 15.0999C23.513 15.4139 23.4171 15.7223 23.308 16.0251H0.692C0.584816 15.7223 0.488913 15.4139 0.404294 15.0999C0.141033 14.1108 0 13.0728 0 12.0009C0 10.9291 0.141033 9.89109 0.404294 8.90198C0.488913 8.58795 0.582935 8.27956 0.692 7.97681H23.3099C23.4171 8.27956 23.513 8.58795 23.5976 8.90198C23.8608 9.89109 24.0019 10.9291 24.0019 12.0009H24Z"
            fill="white"
          />
          <path
            d="M14.4136 0.242576V23.7555C13.6332 23.9154 12.8265 23.9981 11.9991 23.9981C11.1717 23.9981 10.365 23.9135 9.58459 23.7555V0.242576C10.365 0.0846196 11.1736 0 12.001 0C12.8283 0 13.6351 0.0846196 14.4154 0.242576H14.4136Z"
            fill="#CF142B"
          />
          <path
            d="M24 12.001C24 12.8284 23.9154 13.6351 23.7574 14.4154H0.242576C0.0827392 13.6351 0 12.8284 0 12.001C0 11.1736 0.0846196 10.3669 0.242576 9.58649H23.7555C23.9154 10.3669 23.9981 11.1736 23.9981 12.001H24Z"
            fill="#CF142B"
          />
        </g>
        <defs>
          <clipPath id="clip0_1110_4937">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function FlagEnUSIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_11184_22148)">
          <path
            d="M20.4871 20.4869C25.1738 15.8003 25.1738 8.20169 20.4871 3.51503C15.8005 -1.17163 8.2019 -1.17163 3.51524 3.51503C-1.17142 8.20169 -1.17142 15.8003 3.51524 20.4869C8.2019 25.1736 15.8005 25.1736 20.4871 20.4869Z"
            fill="#B22234"
          />
          <path
            d="M20.6605 20.3087C19.9855 21.012 19.2258 21.6325 18.3984 22.1553H5.60201C4.77462 21.6325 4.01492 21.012 3.33984 20.3087H20.6587H20.6605Z"
            fill="white"
          />
          <path
            d="M23.0809 16.6155C22.812 17.2623 22.4885 17.8791 22.1143 18.4621H1.88647C1.51414 17.8791 1.18882 17.2623 0.919922 16.6155H23.079H23.0809Z"
            fill="white"
          />
          <path
            d="M23.9656 12.9242C23.9186 13.5541 23.8208 14.1709 23.6798 14.7708H0.320982C0.17995 14.1709 0.0821671 13.5541 0.0351562 12.9242H23.9656Z"
            fill="white"
          />
          <path
            d="M23.9656 11.0777H0.0351562C0.0821671 10.4477 0.17995 9.83094 0.320982 9.23108H23.6779C23.8208 9.83094 23.9167 10.4477 23.9637 11.0777H23.9656Z"
            fill="white"
          />
          <path
            d="M23.0809 7.38443H0.919922C1.18882 6.73756 1.51226 6.12078 1.88647 5.53784H22.1143C22.4866 6.12078 22.812 6.73756 23.0809 7.38443Z"
            fill="white"
          />
          <path
            d="M20.6606 3.69315H3.3418C4.01499 2.98986 4.77469 2.36932 5.60208 1.84656H18.3984C19.2258 2.36932 19.9855 2.98986 20.6606 3.69315Z"
            fill="white"
          />
          <path
            d="M13.8325 0.139152V12.9242H0.0357283C0.0112826 12.6196 0 12.3112 0 12.0009C0 11.6907 0.0112826 11.3823 0.0357283 11.0776C0.0827392 10.4477 0.180522 9.83092 0.321555 9.23106C0.471989 8.59359 0.673196 7.97681 0.921413 7.38447C1.19032 6.7376 1.51375 6.12082 1.88796 5.53788C2.31294 4.87597 2.79997 4.25731 3.34341 3.6913C4.01661 2.98801 4.77631 2.36747 5.6037 1.84471C7.45405 0.676957 9.64851 0 12.0009 0C12.6234 0 13.2364 0.0470109 13.8325 0.139152Z"
            fill="#3C3B6E"
          />
          <path
            d="M0.420257 9.1333L0.585735 9.64289L0.277344 9.41912C0.290507 9.35519 0.30555 9.29313 0.320594 9.23108C0.352561 9.09193 0.388289 8.95465 0.425898 8.81738H0.852757L0.418376 9.1333H0.420257Z"
            fill="white"
          />
          <path
            d="M0.421218 11.7188L0.586696 12.2284L0.152315 11.9125L0 12.0235V12.0009C0 11.7658 0.00564131 11.5327 0.0206848 11.2995L0.152315 10.8933L0.317794 11.4029H0.853718L0.419337 11.7188H0.421218Z"
            fill="white"
          />
          <path
            d="M1.98334 5.38928L2.10557 5.76725L1.85547 5.58673C1.86487 5.57168 1.87427 5.55476 1.88556 5.53972C1.91752 5.48895 1.94949 5.44005 1.98334 5.38928Z"
            fill="white"
          />
          <path
            d="M2.37439 4.94177L2.20703 5.06212C2.23524 5.02075 2.26532 4.98126 2.29353 4.94177H2.37251H2.37439Z"
            fill="white"
          />
          <path
            d="M1.67211 7.01587L1.50663 7.52547H0.970703L1.40508 7.84138L1.23772 8.35098L1.67211 8.03695L2.10649 8.35098L1.94101 7.84138L2.37539 7.52547H1.83758L1.67211 7.01587Z"
            fill="white"
          />
          <path
            d="M1.83758 10.1111L1.67211 9.59961L1.50663 10.1111H0.970703L1.40508 10.4251L1.23772 10.9366L1.67211 10.6207L2.10649 10.9366L1.94101 10.4251L2.37539 10.1111H1.83758Z"
            fill="white"
          />
          <path
            d="M3.45914 3.96386L3.62462 4.47346L3.19024 4.15755L2.75586 4.47346L2.82544 4.26097C2.99091 4.06541 3.16203 3.87548 3.33879 3.6912C3.35196 3.67616 3.367 3.66299 3.38204 3.64795H3.89352L3.45914 3.96386Z"
            fill="white"
          />
          <path
            d="M3.19352 5.724L3.02616 6.2336H2.49023L2.92462 6.54951L2.75914 7.05911L3.19352 6.7432L3.62602 7.05911L3.46054 6.54951L3.89492 6.2336H3.359L3.19352 5.724Z"
            fill="white"
          />
          <path
            d="M3.19352 8.30774L3.02616 8.81734H2.49023L2.92462 9.13325L2.75914 9.64473L3.19352 9.32882L3.62602 9.64473L3.46054 9.13325L3.89492 8.81734H3.359L3.19352 8.30774Z"
            fill="white"
          />
          <path
            d="M3.359 11.4029L3.19352 10.8933L3.02616 11.4029H2.49023L2.92462 11.7188L2.75914 12.2284L3.19352 11.9125L3.62602 12.2284L3.46054 11.7188L3.89492 11.4029H3.359Z"
            fill="white"
          />
          <path
            d="M4.98063 2.67204L5.14611 3.18164L4.71172 2.86573L4.27734 3.18164L4.44094 2.67957C4.58197 2.56298 4.72677 2.45203 4.87344 2.34485L4.8772 2.35613H5.41313L4.97875 2.67204H4.98063Z"
            fill="white"
          />
          <path
            d="M4.71305 4.4303L4.54757 4.94178H4.00977L4.44415 5.25581L4.27867 5.76729L4.71305 5.45137L5.14743 5.76729L4.98195 5.25581L5.41445 4.94178H4.87853L4.71305 4.4303Z"
            fill="white"
          />
          <path
            d="M4.71305 7.01587L4.54757 7.52547H4.00977L4.44415 7.84138L4.27867 8.35098L4.71305 8.03695L5.14743 8.35098L4.98195 7.84138L5.41445 7.52547H4.87853L4.71305 7.01587Z"
            fill="white"
          />
          <path
            d="M4.87853 10.1111L4.71305 9.59961L4.54757 10.1111H4.00977L4.44415 10.4251L4.27867 10.9366L4.71305 10.6207L5.14743 10.9366L4.98195 10.4251L5.41445 10.1111H4.87853Z"
            fill="white"
          />
          <path
            d="M6.50016 1.3802L6.66564 1.8898L6.23126 1.57388L5.79688 1.8898L5.86269 1.68483C6.13911 1.51935 6.42118 1.36515 6.71265 1.22412L6.50016 1.3802Z"
            fill="white"
          />
          <path
            d="M6.23265 3.13843L6.06717 3.64803H5.53125L5.96563 3.96394L5.79827 4.47542L6.23265 4.1595L6.66703 4.47542L6.50155 3.96394L6.93594 3.64803H6.39813L6.23265 3.13843Z"
            fill="white"
          />
          <path
            d="M6.23265 5.724L6.06717 6.2336H5.53125L5.96563 6.54951L5.79827 7.05911L6.23265 6.7432L6.66703 7.05911L6.50155 6.54951L6.93594 6.2336H6.39813L6.23265 5.724Z"
            fill="white"
          />
          <path
            d="M6.23265 8.30774L6.06717 8.81734H5.53125L5.96563 9.13325L5.79827 9.64473L6.23265 9.32882L6.66703 9.64473L6.50155 9.13325L6.93594 8.81734H6.39813L6.23265 8.30774Z"
            fill="white"
          />
          <path
            d="M6.39813 11.4029L6.23265 10.8933L6.06717 11.4029H5.53125L5.96563 11.7188L5.79827 12.2284L6.23265 11.9125L6.66703 12.2284L6.50155 11.7188L6.93594 11.4029H6.39813Z"
            fill="white"
          />
          <path
            d="M7.75211 1.84656L7.58475 2.35616H7.04883L7.48321 2.67207L7.31773 3.18167L7.75211 2.86763L8.18461 3.18167L8.01913 2.67207L8.45351 2.35616H7.91759L7.75211 1.84656Z"
            fill="white"
          />
          <path
            d="M7.75211 4.4303L7.58475 4.94178H7.04883L7.48321 5.25581L7.31773 5.76729L7.75211 5.45137L8.18461 5.76729L8.01913 5.25581L8.45351 4.94178H7.91759L7.75211 4.4303Z"
            fill="white"
          />
          <path
            d="M7.75211 7.01587L7.58475 7.52547H7.04883L7.48321 7.84138L7.31773 8.35098L7.75211 8.03695L8.18461 8.35098L8.01913 7.84138L8.45351 7.52547H7.91759L7.75211 7.01587Z"
            fill="white"
          />
          <path
            d="M7.91759 10.1111L7.75211 9.59961L7.58475 10.1111H7.04883L7.48321 10.4251L7.31773 10.9366L7.75211 10.6207L8.18461 10.9366L8.01913 10.4251L8.45351 10.1111H7.91759Z"
            fill="white"
          />
          <path
            d="M9.27164 0.554688L9.10616 1.06429H8.56836L9.00274 1.3802L8.83726 1.8898L9.27164 1.57388L9.70602 1.8898L9.54055 1.3802L9.97305 1.06429H9.43712L9.27164 0.554688Z"
            fill="white"
          />
          <path
            d="M9.27164 3.13843L9.10616 3.64803H8.56836L9.00274 3.96394L8.83726 4.47542L9.27164 4.1595L9.70602 4.47542L9.54055 3.96394L9.97305 3.64803H9.43712L9.27164 3.13843Z"
            fill="white"
          />
          <path
            d="M9.27164 5.724L9.10616 6.2336H8.56836L9.00274 6.54951L8.83726 7.05911L9.27164 6.7432L9.70602 7.05911L9.54055 6.54951L9.97305 6.2336H9.43712L9.27164 5.724Z"
            fill="white"
          />
          <path
            d="M9.27164 8.30774L9.10616 8.81734H8.56836L9.00274 9.13325L8.83726 9.64473L9.27164 9.32882L9.70602 9.64473L9.54055 9.13325L9.97305 8.81734H9.43712L9.27164 8.30774Z"
            fill="white"
          />
          <path
            d="M9.43712 11.4029L9.27164 10.8933L9.10616 11.4029H8.56836L9.00274 11.7188L8.83726 12.2284L9.27164 11.9125L9.70602 12.2284L9.54055 11.7188L9.97305 11.4029H9.43712Z"
            fill="white"
          />
          <path
            d="M10.7912 1.84656L10.6258 2.35616H10.0898L10.5242 2.67207L10.3569 3.18167L10.7912 2.86763L11.2256 3.18167L11.0601 2.67207L11.4945 2.35616H10.9567L10.7912 1.84656Z"
            fill="white"
          />
          <path
            d="M10.7912 4.4303L10.6258 4.94178H10.0898L10.5242 5.25581L10.3569 5.76729L10.7912 5.45137L11.2256 5.76729L11.0601 5.25581L11.4945 4.94178H10.9567L10.7912 4.4303Z"
            fill="white"
          />
          <path
            d="M10.7912 7.01587L10.6258 7.52547H10.0898L10.5242 7.84138L10.3569 8.35098L10.7912 8.03695L11.2256 8.35098L11.0601 7.84138L11.4945 7.52547H10.9567L10.7912 7.01587Z"
            fill="white"
          />
          <path
            d="M10.9567 10.1111L10.7912 9.59961L10.6258 10.1111H10.0898L10.5242 10.4251L10.3569 10.9366L10.7912 10.6207L11.2256 10.9366L11.0601 10.4251L11.4945 10.1111H10.9567Z"
            fill="white"
          />
          <path
            d="M12.0438 1.3802L11.8783 1.8898L12.3127 1.57388L12.7452 1.8898L12.5797 1.3802L13.0141 1.06429H12.4781L12.3127 0.554688L12.1453 1.06429H11.6094L12.0438 1.3802Z"
            fill="white"
          />
          <path
            d="M12.3127 3.13843L12.1453 3.64803H11.6094L12.0438 3.96394L11.8783 4.47542L12.3127 4.1595L12.7452 4.47542L12.5797 3.96394L13.0141 3.64803H12.4781L12.3127 3.13843Z"
            fill="white"
          />
          <path
            d="M12.3127 5.724L12.1453 6.2336H11.6094L12.0438 6.54951L11.8783 7.05911L12.3127 6.7432L12.7452 7.05911L12.5797 6.54951L13.0141 6.2336H12.4781L12.3127 5.724Z"
            fill="white"
          />
          <path
            d="M12.3127 8.30774L12.1453 8.81734H11.6094L12.0438 9.13325L11.8783 9.64473L12.3127 9.32882L12.7452 9.64473L12.5797 9.13325L13.0141 8.81734H12.4781L12.3127 8.30774Z"
            fill="white"
          />
          <path
            d="M12.4781 11.4029L12.3127 10.8933L12.1453 11.4029H11.6094L12.0438 11.7188L11.8783 12.2284L12.3127 11.9125L12.7452 12.2284L12.5797 11.7188L13.0141 11.4029H12.4781Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_11184_22148">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function FlagSkIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_11184_22206)">
          <path
            d="M23.3164 16.0006C21.6692 20.6622 17.2238 24 12 24C6.77613 24 2.3289 20.6603 0.681641 16.0006H23.3164Z"
            fill="#EE1C25"
          />
          <path
            d="M24 12.0009C24 13.4037 23.7593 14.7501 23.3174 16.0006H0.682598C0.240696 14.7501 0 13.4037 0 12.0009C0 10.5981 0.240696 9.25171 0.682598 8.00122H23.3174C23.7593 9.25171 24 10.5981 24 12.0009Z"
            fill="#0B4EA2"
          />
          <path
            d="M23.3164 7.99937H0.681641C2.3289 3.33965 6.77425 0 12 0C17.2257 0 21.6692 3.33965 23.3164 7.99937Z"
            fill="white"
          />
          <path
            d="M10.6182 18.5411C8.46702 17.505 5.39062 15.4478 5.39062 11.3804C5.39062 7.31304 5.58431 5.46082 5.58431 5.46082H15.6522C15.6522 5.46082 15.8458 7.31116 15.8458 11.3804C15.8458 15.4497 12.7695 17.505 10.6164 18.5411H10.6182Z"
            fill="white"
          />
          <path
            d="M10.6173 17.9996C8.64285 17.0481 5.82031 15.162 5.82031 11.4294C5.82031 7.69669 5.99895 5.99866 5.99895 5.99866H15.2357C15.2357 5.99866 15.4143 7.69669 15.4143 11.4294C15.4143 15.162 12.5918 17.0481 10.6173 17.9996Z"
            fill="#EE1C25"
          />
          <path
            d="M11.0385 10.4515C11.5726 10.4609 12.6162 10.4816 13.5432 10.1713C13.5432 10.1713 13.5188 10.5042 13.5188 10.8897C13.5188 11.2752 13.5432 11.6099 13.5432 11.6099C12.6914 11.324 11.6402 11.3184 11.0385 11.3259V13.3869H10.1942V11.3259C9.59245 11.3184 8.54129 11.3259 7.68945 11.6099C7.68945 11.6099 7.7139 11.277 7.7139 10.8897C7.7139 10.5023 7.68945 10.1713 7.68945 10.1713C8.61839 10.4816 9.66015 10.4609 10.1942 10.4515V9.1559C9.70716 9.15214 9.00576 9.17471 8.21221 9.43985C8.21221 9.43985 8.23666 9.10701 8.23666 8.71964C8.23666 8.33227 8.21221 8.00132 8.21221 8.00132C9.00388 8.26646 9.70528 8.2909 10.1923 8.28526C10.1679 7.46539 9.92905 6.43115 9.92905 6.43115C9.92905 6.43115 10.4198 6.46876 10.6173 6.46876C10.8147 6.46876 11.3055 6.43115 11.3055 6.43115C11.3055 6.43115 11.0667 7.46539 11.0423 8.28526C11.5293 8.28902 12.2307 8.26646 13.0224 8.00132C13.0224 8.00132 12.9979 8.33415 12.9979 8.71964C12.9979 9.10513 13.0224 9.43985 13.0224 9.43985C12.2288 9.17471 11.5274 9.15026 11.0404 9.1559V10.4515H11.0385Z"
            fill="white"
          />
          <path
            d="M10.6191 13.1631C9.62432 13.1631 9.09216 14.5414 9.09216 14.5414C9.09216 14.5414 8.79693 13.8871 7.98646 13.8871C7.43738 13.8871 7.03308 14.376 6.77734 14.8273C7.77586 16.4162 9.36858 17.3959 10.6191 17.9977C11.8714 17.3941 13.4642 16.4144 14.4627 14.8273C14.2051 14.376 13.8008 13.8871 13.2536 13.8871C12.4431 13.8871 12.146 14.5414 12.146 14.5414C12.146 14.5414 11.6138 13.1631 10.6191 13.1631Z"
            fill="#0B4EA2"
          />
        </g>
        <defs>
          <clipPath id="clip0_11184_22206">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function FirefoxIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.7768 8.05139C22.2714 6.83529 21.2462 5.52225 20.4434 5.10718C21.016 6.21617 21.4134 7.40717 21.6213 8.63783L21.6234 8.65734C20.3083 5.37849 18.0781 4.05644 16.2566 1.17766C16.1645 1.0321 16.0724 0.886239 15.9826 0.732276C15.9313 0.644339 15.8902 0.565107 15.8545 0.492177C15.7789 0.345883 15.7207 0.191274 15.681 0.0314873C15.6811 0.0241139 15.6784 0.016979 15.6735 0.0114435C15.6687 0.00590809 15.6619 0.00235959 15.6546 0.00147496C15.6474 -0.000491652 15.6399 -0.000491652 15.6327 0.00147496C15.6312 0.00147496 15.6288 0.00417607 15.627 0.00477632C15.6252 0.00537656 15.6213 0.00807767 15.6186 0.00927817L15.6231 0.00147496C12.7014 1.71218 11.7101 4.87908 11.6188 6.46313C10.452 6.54334 9.3365 6.9733 8.41772 7.69694C8.32186 7.61574 8.22167 7.5398 8.11759 7.46945C7.85255 6.54175 7.84125 5.55993 8.08488 4.62638C7.01192 5.14617 6.05853 5.88301 5.28503 6.79027H5.27963C4.81864 6.20593 4.85105 4.27913 4.87746 3.87667C4.74108 3.93148 4.6109 4.00059 4.4891 4.08285C4.08215 4.3733 3.70171 4.69921 3.35223 5.05676C2.954 5.46052 2.59028 5.89692 2.26489 6.36139V6.36319V6.36109C1.51705 7.42129 0.98663 8.61913 0.704245 9.88544L0.688638 9.96227C0.666729 10.0646 0.587797 10.5772 0.574291 10.6886C0.574291 10.6973 0.572491 10.7054 0.57159 10.7141C0.46977 11.2433 0.406676 11.7792 0.382812 12.3176L0.382813 12.3777C0.385363 15.2902 1.48037 18.0957 3.45143 20.2399C5.42249 22.3841 8.12617 23.7109 11.0282 23.958C13.9301 24.2052 16.8192 23.3547 19.1245 21.5747C21.4298 19.7948 22.9835 17.2148 23.4785 14.3447C23.498 14.1946 23.5139 14.0461 23.5313 13.8945C23.7709 11.9143 23.5115 9.90572 22.7768 8.05139ZM9.37031 17.1565C9.42463 17.1826 9.47565 17.2109 9.53148 17.2358L9.53958 17.2409C9.48316 17.2139 9.42673 17.1857 9.37031 17.1565ZM21.6243 8.66004V8.64893L21.6264 8.66124L21.6243 8.66004Z"
          fill="url(#paint0_linear_11781_4855)"
        />
        <path
          d="M22.7768 8.05139C22.2714 6.83529 21.2462 5.52225 20.4434 5.10718C21.016 6.21617 21.4134 7.40718 21.6213 8.63783V8.64893L21.6234 8.66124C22.52 11.2268 22.3903 14.0397 21.2615 16.5119C19.9284 19.3723 16.7014 22.3043 11.6503 22.1617C6.1926 22.0071 1.38613 17.9573 0.487556 12.6529C0.323988 11.8164 0.487556 11.3924 0.569789 10.7126C0.457612 11.2406 0.395014 11.778 0.382813 12.3176L0.382812 12.3777C0.385363 15.2902 1.48037 18.0957 3.45143 20.2399C5.42249 22.3841 8.12617 23.7109 11.0282 23.958C13.9301 24.2052 16.8192 23.3547 19.1245 21.5747C21.4298 19.7948 22.9835 17.2148 23.4785 14.3447C23.498 14.1946 23.5139 14.0461 23.5313 13.8945C23.7709 11.9143 23.5115 9.90572 22.7768 8.05139Z"
          fill="url(#paint1_radial_11781_4855)"
        />
        <path
          d="M22.7768 8.05139C22.2714 6.83529 21.2462 5.52225 20.4434 5.10718C21.016 6.21617 21.4134 7.40718 21.6213 8.63783V8.64893L21.6234 8.66124C22.52 11.2268 22.3903 14.0397 21.2615 16.5119C19.9284 19.3723 16.7014 22.3043 11.6503 22.1617C6.1926 22.0071 1.38613 17.9573 0.487556 12.6529C0.323988 11.8164 0.487556 11.3924 0.569789 10.7126C0.457612 11.2406 0.395014 11.778 0.382813 12.3176L0.382812 12.3777C0.385363 15.2902 1.48037 18.0957 3.45143 20.2399C5.42249 22.3841 8.12617 23.7109 11.0282 23.958C13.9301 24.2052 16.8192 23.3547 19.1245 21.5747C21.4298 19.7948 22.9835 17.2148 23.4785 14.3447C23.498 14.1946 23.5139 14.0461 23.5313 13.8945C23.7709 11.9143 23.5115 9.90572 22.7768 8.05139Z"
          fill="url(#paint2_radial_11781_4855)"
        />
        <path
          d="M17.1246 9.41874C17.1498 9.43645 17.1732 9.45415 17.1969 9.47186C16.9048 8.95376 16.541 8.4794 16.1165 8.06278C12.5012 4.44689 15.169 0.222656 15.6189 0.00806756L15.6234 0.00146484C12.7017 1.71217 11.7104 4.87907 11.6191 6.46312C11.7548 6.45382 11.8893 6.44241 12.0279 6.44241C13.0646 6.44431 14.0823 6.72071 14.9775 7.24349C15.8727 7.76627 16.6135 8.51679 17.1246 9.41874Z"
          fill="url(#paint3_radial_11781_4855)"
        />
        <path
          d="M12.0345 10.1408C12.0153 10.4301 10.993 11.428 10.6356 11.428C7.32794 11.428 6.79102 13.429 6.79102 13.429C6.93748 15.1138 8.11156 16.5016 9.53084 17.2357C9.59567 17.2693 9.6614 17.2996 9.72712 17.3294C9.84097 17.3798 9.95482 17.4264 10.0687 17.4692C10.5558 17.6416 11.0659 17.74 11.5822 17.7612C17.3797 18.0332 18.5027 10.8284 14.319 8.73773C15.306 8.60931 16.3055 8.85199 17.1237 9.41871C16.6126 8.51676 15.8718 7.76624 14.9766 7.24346C14.0813 6.72067 13.0637 6.44428 12.027 6.44238C11.8889 6.44238 11.7539 6.45379 11.6182 6.46309C10.4514 6.54329 9.33587 6.97326 8.41708 7.6969C8.59446 7.84696 8.79464 8.04744 9.21631 8.46311C10.0056 9.24073 12.03 10.0463 12.0345 10.1408Z"
          fill="url(#paint4_radial_11781_4855)"
        />
        <path
          d="M12.0345 10.1408C12.0153 10.4301 10.993 11.428 10.6356 11.428C7.32794 11.428 6.79102 13.429 6.79102 13.429C6.93748 15.1138 8.11156 16.5016 9.53084 17.2357C9.59567 17.2693 9.6614 17.2996 9.72712 17.3294C9.84097 17.3798 9.95482 17.4264 10.0687 17.4692C10.5558 17.6416 11.0659 17.74 11.5822 17.7612C17.3797 18.0332 18.5027 10.8284 14.319 8.73773C15.306 8.60931 16.3055 8.85199 17.1237 9.41871C16.6126 8.51676 15.8718 7.76624 14.9766 7.24346C14.0813 6.72067 13.0637 6.44428 12.027 6.44238C11.8889 6.44238 11.7539 6.45379 11.6182 6.46309C10.4514 6.54329 9.33587 6.97326 8.41708 7.6969C8.59446 7.84696 8.79464 8.04744 9.21631 8.46311C10.0056 9.24073 12.03 10.0463 12.0345 10.1408Z"
          fill="url(#paint5_radial_11781_4855)"
        />
        <path
          d="M7.87567 7.31017C7.96991 7.37019 8.04764 7.42242 8.11577 7.46953C7.85073 6.54184 7.83943 5.56002 8.08306 4.62646C7.01009 5.14626 6.0567 5.88309 5.2832 6.79035C5.33993 6.78885 7.02722 6.75854 7.87567 7.31017Z"
          fill="url(#paint6_radial_11781_4855)"
        />
        <path
          d="M0.490022 12.6528C1.38769 17.9572 6.19507 22.0071 11.6528 22.1617C16.7039 22.3045 19.9308 19.3723 21.264 16.5118C22.3928 14.0396 22.5225 11.2268 21.6259 8.66121V8.6501C21.6259 8.6414 21.6241 8.6363 21.6259 8.639L21.628 8.6585C22.0407 11.3527 20.6703 13.9629 18.528 15.7279L18.5214 15.7429C14.3473 19.1424 10.3527 17.794 9.54415 17.2435C9.48772 17.2165 9.4313 17.1884 9.37488 17.1592C6.94118 15.9959 5.93576 13.7786 6.15125 11.877C5.57354 11.8856 5.00576 11.7264 4.5167 11.4187C4.02764 11.1111 3.63829 10.6682 3.39582 10.1438C4.03466 9.75244 4.76309 9.53118 5.51169 9.50113C6.26029 9.47108 7.00411 9.63323 7.67228 9.97215C9.0498 10.5975 10.6173 10.6591 12.0397 10.1438C12.0352 10.0493 10.0108 9.24344 9.22151 8.46613C8.79984 8.05045 8.59966 7.85027 8.42229 7.69991C8.32643 7.61871 8.22624 7.54277 8.12216 7.47242C8.05313 7.4253 7.9754 7.37428 7.88206 7.31305C7.03361 6.76142 5.34632 6.79174 5.2905 6.79324H5.28509C4.8241 6.2089 4.85652 4.2821 4.88293 3.87964C4.74655 3.93445 4.61637 4.00356 4.49457 4.08582C4.08762 4.37627 3.70717 4.70218 3.3577 5.05972C2.95804 5.46235 2.59282 5.89775 2.26585 6.36136V6.36316V6.36106C1.51802 7.42126 0.987596 8.6191 0.705211 9.88541C0.699508 9.90912 0.286238 11.7159 0.490022 12.6528Z"
          fill="url(#paint7_radial_11781_4855)"
        />
        <path
          d="M16.1177 8.06279C16.5423 8.47987 16.906 8.95474 17.1981 9.47337C17.262 9.52169 17.3218 9.56971 17.3725 9.61623C20.0097 12.0472 18.6279 15.4836 18.525 15.7282C20.6672 13.9632 22.0364 11.353 21.6249 8.65884C20.3092 5.37849 18.079 4.05644 16.2575 1.17766C16.1654 1.0321 16.0732 0.886239 15.9835 0.732276C15.9322 0.644339 15.8911 0.565107 15.8554 0.492177C15.7798 0.345883 15.7216 0.191274 15.6819 0.0314873C15.6819 0.0241139 15.6793 0.016979 15.6744 0.0114435C15.6695 0.00590809 15.6628 0.00235959 15.6555 0.00147496C15.6483 -0.000491652 15.6407 -0.000491652 15.6336 0.00147496C15.6321 0.00147496 15.6297 0.00417607 15.6279 0.00477632C15.6261 0.00537656 15.6222 0.00807767 15.6195 0.00927817C15.1696 0.222666 12.5018 4.4469 16.1177 8.06279Z"
          fill="url(#paint8_radial_11781_4855)"
        />
        <path
          d="M17.3688 9.61464C17.3181 9.56812 17.2584 9.5201 17.1944 9.47178C17.1707 9.45407 17.1473 9.43637 17.1221 9.41866C16.3039 8.85194 15.3044 8.60926 14.3175 8.73768C18.5012 10.8295 17.3787 18.0331 11.5806 17.7612C11.0644 17.74 10.5542 17.6416 10.0671 17.4692C9.95327 17.4266 9.83942 17.3799 9.72558 17.3293C9.65985 17.2993 9.59412 17.2693 9.5293 17.2357L9.5374 17.2408C10.3459 17.7927 14.3394 19.1412 18.5147 15.7402L18.5213 15.7252C18.6254 15.4821 20.0072 12.0447 17.3688 9.61464Z"
          fill="url(#paint9_radial_11781_4855)"
        />
        <path
          d="M6.79102 13.429C6.79102 13.429 7.32794 11.4281 10.6356 11.4281C10.9931 11.4281 12.0162 10.4302 12.0345 10.1408C10.6121 10.6561 9.04461 10.5945 7.66708 9.96918C6.99892 9.63027 6.2551 9.46811 5.5065 9.49816C4.7579 9.52821 4.02947 9.74947 3.39062 10.1408C3.63309 10.6653 4.02245 11.1081 4.51151 11.4158C5.00057 11.7234 5.56835 11.8826 6.14606 11.8741C5.93057 13.7759 6.93598 15.9933 9.36968 17.1562C9.42401 17.1823 9.47503 17.2106 9.53085 17.2355C8.11037 16.5017 6.93748 15.1139 6.79102 13.429Z"
          fill="url(#paint10_radial_11781_4855)"
        />
        <path
          d="M22.7768 8.05139C22.2714 6.83529 21.2462 5.52225 20.4434 5.10718C21.016 6.21617 21.4134 7.40717 21.6213 8.63783L21.6234 8.65734C20.3083 5.37849 18.0781 4.05644 16.2566 1.17766C16.1645 1.0321 16.0724 0.886239 15.9826 0.732276C15.9313 0.644339 15.8902 0.565107 15.8545 0.492177C15.7789 0.345883 15.7207 0.191274 15.681 0.0314873C15.6811 0.0241139 15.6784 0.016979 15.6735 0.0114435C15.6687 0.00590809 15.6619 0.00235959 15.6546 0.00147496C15.6474 -0.000491652 15.6399 -0.000491652 15.6327 0.00147496C15.6312 0.00147496 15.6288 0.00417607 15.627 0.00477632C15.6252 0.00537656 15.6213 0.00807767 15.6186 0.00927817L15.6231 0.00147496C12.7014 1.71218 11.7101 4.87908 11.6188 6.46313C11.7545 6.45383 11.8889 6.44242 12.0276 6.44242C13.0643 6.44432 14.082 6.72072 14.9772 7.2435C15.8724 7.76628 16.6132 8.5168 17.1243 9.41875C16.3061 8.85203 15.3066 8.60935 14.3196 8.73777C18.5034 10.8296 17.3809 18.0332 11.5828 17.7613C11.0666 17.7401 10.5564 17.6416 10.0693 17.4693C9.95545 17.4266 9.8416 17.38 9.72776 17.3294C9.66203 17.2994 9.5963 17.2694 9.53148 17.2358L9.53958 17.2409C9.48316 17.2139 9.42673 17.1857 9.37031 17.1565C9.42463 17.1826 9.47565 17.2109 9.53148 17.2358C8.11099 16.5017 6.93811 15.1139 6.79165 13.429C6.79165 13.429 7.32857 11.4281 10.6362 11.4281C10.9937 11.4281 12.0168 10.4302 12.0351 10.1408C12.0306 10.0463 10.0063 9.24048 9.21695 8.46316C8.79527 8.04749 8.59509 7.8473 8.41772 7.69694C8.32186 7.61574 8.22167 7.5398 8.11759 7.46945C7.85255 6.54175 7.84125 5.55993 8.08488 4.62638C7.01192 5.14617 6.05853 5.88301 5.28503 6.79027H5.27963C4.81864 6.20593 4.85105 4.27913 4.87746 3.87667C4.74108 3.93148 4.6109 4.00059 4.4891 4.08285C4.08215 4.3733 3.70171 4.69921 3.35223 5.05676C2.954 5.46052 2.59028 5.89692 2.26489 6.36139V6.36319V6.36109C1.51705 7.42129 0.98663 8.61913 0.704245 9.88544L0.688638 9.96227C0.666729 10.0646 0.568589 10.5844 0.554483 10.6961C0.554483 10.6874 0.554483 10.7045 0.554483 10.6961C0.464719 11.2327 0.407392 11.7742 0.382812 12.3176L0.382813 12.3777C0.385363 15.2902 1.48037 18.0957 3.45143 20.2399C5.42249 22.3841 8.12617 23.7109 11.0282 23.958C13.9301 24.2052 16.8192 23.3547 19.1245 21.5747C21.4298 19.7948 22.9835 17.2148 23.4785 14.3447C23.498 14.1946 23.5139 14.0461 23.5313 13.8945C23.7709 11.9143 23.5115 9.90572 22.7768 8.05139ZM21.6228 8.64893L21.6249 8.66124L21.6228 8.64893Z"
          fill="url(#paint11_linear_11781_4855)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_11781_4855"
            x1="21.2372"
            y1="3.7182"
            x2="1.92754"
            y2="22.3484"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.048" stopColor="#FFF44F" />
            <stop offset="0.111" stopColor="#FFE847" />
            <stop offset="0.225" stopColor="#FFC830" />
            <stop offset="0.368" stopColor="#FF980E" />
            <stop offset="0.401" stopColor="#FF8B16" />
            <stop offset="0.462" stopColor="#FF672A" />
            <stop offset="0.534" stopColor="#FF3647" />
            <stop offset="0.705" stopColor="#E31587" />
          </linearGradient>
          <radialGradient
            id="paint1_radial_11781_4855"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(20.3449 2.66351) scale(24.2491 24.2491)"
          >
            <stop offset="0.129" stopColor="#FFBD4F" />
            <stop offset="0.186" stopColor="#FFAC31" />
            <stop offset="0.247" stopColor="#FF9D17" />
            <stop offset="0.283" stopColor="#FF980E" />
            <stop offset="0.403" stopColor="#FF563B" />
            <stop offset="0.467" stopColor="#FF3750" />
            <stop offset="0.71" stopColor="#F5156C" />
            <stop offset="0.782" stopColor="#EB0878" />
            <stop offset="0.86" stopColor="#E50080" />
          </radialGradient>
          <radialGradient
            id="paint2_radial_11781_4855"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(11.4841 12.5773) scale(24.2491 24.2491)"
          >
            <stop offset="0.3" stopColor="#960E18" />
            <stop offset="0.351" stopColor="#B11927" stopOpacity="0.74" />
            <stop offset="0.435" stopColor="#DB293D" stopOpacity="0.343" />
            <stop offset="0.497" stopColor="#F5334B" stopOpacity="0.094" />
            <stop offset="0.53" stopColor="#FF3750" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint3_radial_11781_4855"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(14.4078 -2.83953) scale(17.5674)"
          >
            <stop offset="0.132" stopColor="#FFF44F" />
            <stop offset="0.252" stopColor="#FFDC3E" />
            <stop offset="0.506" stopColor="#FF9D12" />
            <stop offset="0.526" stopColor="#FF980E" />
          </radialGradient>
          <radialGradient
            id="paint4_radial_11781_4855"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(8.80127 18.9112) scale(11.5461 11.546)"
          >
            <stop offset="0.353" stopColor="#3A8EE6" />
            <stop offset="0.472" stopColor="#5C79F0" />
            <stop offset="0.669" stopColor="#9059FF" />
            <stop offset="1" stopColor="#C139E6" />
          </radialGradient>
          <radialGradient
            id="paint5_radial_11781_4855"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(12.8085 10.5899) rotate(-13.5916) scale(6.12165 7.16692)"
          >
            <stop offset="0.206" stopColor="#9059FF" stopOpacity="0" />
            <stop offset="0.278" stopColor="#8C4FF3" stopOpacity="0.064" />
            <stop offset="0.747" stopColor="#7716A8" stopOpacity="0.45" />
            <stop offset="0.975" stopColor="#6E008B" stopOpacity="0.6" />
          </radialGradient>
          <radialGradient
            id="paint6_radial_11781_4855"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(11.1782 1.67148) scale(8.30622)"
          >
            <stop stopColor="#FFE226" />
            <stop offset="0.121" stopColor="#FFDB27" />
            <stop offset="0.295" stopColor="#FFC82A" />
            <stop offset="0.502" stopColor="#FFA930" />
            <stop offset="0.732" stopColor="#FF7E37" />
            <stop offset="0.792" stopColor="#FF7139" />
          </radialGradient>
          <radialGradient
            id="paint7_radial_11781_4855"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(17.7078 -3.59719) scale(35.4389 35.4389)"
          >
            <stop offset="0.113" stopColor="#FFF44F" />
            <stop offset="0.456" stopColor="#FF980E" />
            <stop offset="0.622" stopColor="#FF5634" />
            <stop offset="0.716" stopColor="#FF3647" />
            <stop offset="0.904" stopColor="#E31587" />
          </radialGradient>
          <radialGradient
            id="paint8_radial_11781_4855"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(14.7208 -1.62657) rotate(83.976) scale(25.974 17.0465)"
          >
            <stop stopColor="#FFF44F" />
            <stop offset="0.06" stopColor="#FFE847" />
            <stop offset="0.168" stopColor="#FFC830" />
            <stop offset="0.304" stopColor="#FF980E" />
            <stop offset="0.356" stopColor="#FF8B16" />
            <stop offset="0.455" stopColor="#FF672A" />
            <stop offset="0.57" stopColor="#FF3647" />
            <stop offset="0.737" stopColor="#E31587" />
          </radialGradient>
          <radialGradient
            id="paint9_radial_11781_4855"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(10.9814 4.74787) scale(22.1251)"
          >
            <stop offset="0.137" stopColor="#FFF44F" />
            <stop offset="0.48" stopColor="#FF980E" />
            <stop offset="0.592" stopColor="#FF5634" />
            <stop offset="0.655" stopColor="#FF3647" />
            <stop offset="0.904" stopColor="#E31587" />
          </radialGradient>
          <radialGradient
            id="paint10_radial_11781_4855"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(16.8221 6.04284) scale(24.2158 24.2158)"
          >
            <stop offset="0.094" stopColor="#FFF44F" />
            <stop offset="0.231" stopColor="#FFE141" />
            <stop offset="0.509" stopColor="#FFAF1E" />
            <stop offset="0.626" stopColor="#FF980E" />
          </radialGradient>
          <linearGradient
            id="paint11_linear_11781_4855"
            x1="21.0052"
            y1="3.61856"
            x2="4.57463"
            y2="20.0488"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.167" stopColor="#FFF44F" stopOpacity="0.8" />
            <stop offset="0.266" stopColor="#FFF44F" stopOpacity="0.634" />
            <stop offset="0.489" stopColor="#FFF44F" stopOpacity="0.217" />
            <stop offset="0.6" stopColor="#FFF44F" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function ChromeIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.9713 0.342885C11.9713 0.342885 18.8192 0.0355848 22.4498 6.91874H11.3886C11.3886 6.91874 9.30118 6.85146 7.51802 9.38387C7.00579 10.4468 6.4552 11.5417 7.07307 13.6995C6.18299 12.1916 2.34766 5.51334 2.34766 5.51334C2.34766 5.51334 5.05289 0.615 11.9712 0.342885H11.9713Z"
          fill="#EF3F36"
        />
        <path
          d="M22.0932 17.8166C22.0932 17.8166 18.9333 23.9026 11.1602 23.6016C12.1206 21.94 16.6923 14.0228 16.6923 14.0228C16.6923 14.0228 17.7968 12.2492 16.4938 9.43827C15.831 8.46182 15.1555 7.44055 12.9786 6.89623C14.7298 6.88032 22.4294 6.89623 22.4294 6.89623C22.4294 6.89623 25.3139 11.6889 22.0932 17.8166Z"
          fill="#FCD900"
        />
        <path
          d="M1.89574 17.8646C1.89574 17.8646 -1.79559 12.0859 2.3535 5.50366C3.31077 7.16526 7.88244 15.0825 7.88244 15.0825C7.88244 15.0825 8.86853 16.9266 11.9515 17.2018C13.1265 17.1154 14.3495 17.0418 15.9119 15.4315C15.0505 16.9554 11.1863 23.6145 11.1863 23.6145C11.1863 23.6145 5.59015 23.7169 1.89564 17.8646H1.89574Z"
          fill="#61BC5B"
        />
        <path
          d="M11.1582 23.6592L12.7141 17.1666C12.7141 17.1666 14.4237 17.0321 15.858 15.4602C14.9679 17.0258 11.1582 23.6592 11.1582 23.6592Z"
          fill="#5AB055"
        />
        <path
          d="M6.75781 12.0731C6.75781 9.21101 9.07893 6.88989 11.941 6.88989C14.8031 6.88989 17.1242 9.21101 17.1242 12.0731C17.1242 14.9352 14.8031 17.2563 11.941 17.2563C9.07893 17.2531 6.75781 14.9352 6.75781 12.0731Z"
          fill="white"
        />
        <path
          d="M7.62695 12.0731C7.62695 9.69129 9.55749 7.75757 11.9426 7.75757C14.3245 7.75757 16.2582 9.6881 16.2582 12.0731C16.2582 14.4551 14.3277 16.3888 11.9426 16.3888C9.56067 16.3888 7.62695 14.4551 7.62695 12.0731Z"
          fill="url(#paint0_linear_11781_20153)"
        />
        <path
          d="M22.4273 6.89955L16.0211 8.7788C16.0211 8.7788 15.0543 7.3605 12.9766 6.89955C14.779 6.88991 22.4273 6.89955 22.4273 6.89955Z"
          fill="#EACA05"
        />
        <path
          d="M6.94824 13.4627C6.04853 11.9035 2.34766 5.51343 2.34766 5.51343L7.09226 10.2068C7.09226 10.2068 6.60558 11.2088 6.78814 12.6431L6.94815 13.4627H6.94824Z"
          fill="#DF3A32"
        />
        <defs>
          <linearGradient
            id="paint0_linear_11781_20153"
            x1="11.9424"
            y1="7.8185"
            x2="11.9424"
            y2="16.129"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#86BBE5" />
            <stop offset="1" stopColor="#1072BA" />
          </linearGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function SafariIcon({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <SvgIcon sx={() => ({ ...sx })}>
      <svg
        width="26"
        height="25"
        viewBox="0 0 26 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24.6179 11.9999C24.6179 15.0811 23.3939 18.036 21.2152 20.2148C19.0365 22.3935 16.0815 23.6175 13.0004 23.6175C9.91919 23.6175 6.96422 22.3935 4.78551 20.2147C2.6068 18.036 1.38281 15.0811 1.38281 11.9999C1.38281 8.91873 2.6068 5.96376 4.78551 3.78504C6.96422 1.60633 9.91919 0.382334 13.0004 0.382324C16.0815 0.382324 19.0365 1.60631 21.2152 3.78503C23.3939 5.96375 24.6179 8.91872 24.6179 11.9999Z"
          fill="url(#paint0_linear_11781_19835)"
          stroke="#CDCDCD"
          strokeWidth="0.753985"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.7074 12C23.7074 14.8397 22.5793 17.5631 20.5713 19.5711C18.5633 21.5791 15.8399 22.7072 13.0002 22.7072C10.1604 22.7072 7.43702 21.5791 5.42903 19.5711C3.42104 17.5631 2.29297 14.8397 2.29297 12C2.29297 9.16023 3.42104 6.43681 5.42903 4.42881C7.43702 2.42082 10.1604 1.29273 13.0002 1.29272C15.8399 1.29272 18.5633 2.42081 20.5713 4.4288C22.5793 6.4368 23.7074 9.16023 23.7074 12Z"
          fill="url(#paint1_radial_11781_19835)"
        />
        <path
          d="M13.0004 1.85107C12.9799 1.85103 12.9596 1.85503 12.9406 1.86286C12.9217 1.87069 12.9044 1.88219 12.8899 1.8967C12.8754 1.91121 12.8639 1.92844 12.8561 1.9474C12.8483 1.96637 12.8442 1.98669 12.8443 2.00721V3.80782C12.8442 3.82834 12.8483 3.84866 12.8561 3.86763C12.8639 3.8866 12.8754 3.90383 12.8899 3.91834C12.9044 3.93284 12.9217 3.94434 12.9406 3.95217C12.9596 3.96 12.9799 3.96401 13.0004 3.96396C13.0209 3.964 13.0413 3.95998 13.0602 3.95215C13.0792 3.94432 13.0964 3.93282 13.1109 3.91831C13.1254 3.9038 13.1369 3.88657 13.1447 3.86761C13.1525 3.84865 13.1565 3.82833 13.1565 3.80782V2.00717C13.1565 1.98666 13.1525 1.96634 13.1447 1.94739C13.1369 1.92843 13.1254 1.9112 13.1109 1.8967C13.0964 1.88219 13.0791 1.8707 13.0602 1.86287C13.0412 1.85504 13.0209 1.85103 13.0004 1.85107H13.0004ZM11.9792 1.91561C11.9686 1.91448 11.958 1.91453 11.9474 1.91575C11.927 1.91784 11.9072 1.92393 11.8892 1.93368C11.8711 1.94344 11.8552 1.95666 11.8423 1.97259C11.8293 1.98852 11.8197 2.00685 11.8139 2.02651C11.8081 2.04618 11.8062 2.06681 11.8083 2.08721L11.887 2.84052C11.8891 2.86093 11.8952 2.88072 11.905 2.89877C11.9147 2.91681 11.9279 2.93275 11.9439 2.94568C11.9598 2.9586 11.9781 2.96825 11.9978 2.97407C12.0175 2.97989 12.0381 2.98177 12.0585 2.97959C12.0789 2.97751 12.0987 2.97142 12.1168 2.96166C12.1348 2.95191 12.1507 2.93868 12.1637 2.92275C12.1766 2.90681 12.1862 2.88848 12.1921 2.86881C12.1979 2.84913 12.1997 2.82851 12.1976 2.8081L12.1189 2.05483C12.1153 2.01905 12.0994 1.98563 12.0739 1.96026C12.0484 1.93488 12.0149 1.9191 11.9791 1.91561H11.9792ZM14.0288 1.91635C13.993 1.91983 13.9595 1.93558 13.934 1.96095C13.9085 1.98631 13.8926 2.01972 13.8889 2.0555L13.8097 2.80874C13.8075 2.82914 13.8094 2.84977 13.8152 2.86945C13.821 2.88913 13.8307 2.90746 13.8436 2.92341C13.8565 2.93935 13.8724 2.95259 13.8905 2.96236C13.9085 2.97213 13.9283 2.97824 13.9487 2.98034C13.9691 2.98252 13.9897 2.98066 14.0094 2.97486C14.0291 2.96905 14.0474 2.95942 14.0633 2.94651C14.0793 2.9336 14.0925 2.91767 14.1023 2.89964C14.112 2.8816 14.1181 2.86181 14.1202 2.84141L14.1995 2.0881C14.2016 2.0677 14.1998 2.04707 14.194 2.0274C14.1881 2.00772 14.1785 1.98939 14.1656 1.97345C14.1527 1.95752 14.1367 1.94429 14.1187 1.93453C14.1007 1.92476 14.0809 1.91866 14.0605 1.91657C14.0499 1.91549 14.0393 1.91543 14.0288 1.91638L14.0288 1.91635ZM10.9301 2.06774C10.9069 2.0678 10.884 2.07303 10.8631 2.08307C10.8422 2.0931 10.8238 2.10768 10.8092 2.12573C10.7947 2.14379 10.7843 2.16486 10.779 2.18742C10.7736 2.20999 10.7733 2.23346 10.7782 2.25614L11.1511 4.01773C11.1553 4.03781 11.1634 4.05686 11.175 4.07379C11.1866 4.09072 11.2014 4.10519 11.2186 4.11637C11.2358 4.12756 11.255 4.13524 11.2752 4.13897C11.2953 4.1427 11.3161 4.14241 11.3361 4.13812C11.3562 4.13392 11.3752 4.12579 11.3922 4.11421C11.4091 4.10263 11.4236 4.08782 11.4347 4.07064C11.4459 4.05345 11.4536 4.03422 11.4574 4.01405C11.4611 3.99389 11.4608 3.97318 11.4565 3.95313L11.0836 2.1915C11.0763 2.1563 11.057 2.12473 11.029 2.10216C11.001 2.07958 10.966 2.06738 10.9301 2.06763V2.06774ZM15.0778 2.06922C15.0419 2.06891 15.0069 2.08107 14.9789 2.10363C14.9509 2.12618 14.9316 2.15774 14.9242 2.19294L14.55 3.95428C14.5457 3.97433 14.5454 3.99504 14.5491 4.01522C14.5528 4.03539 14.5605 4.05463 14.5717 4.07184C14.5828 4.08904 14.5973 4.10386 14.6142 4.11546C14.6312 4.12706 14.6502 4.1352 14.6703 4.13942C14.6903 4.14372 14.711 4.14403 14.7312 4.14031C14.7514 4.13659 14.7706 4.12893 14.7878 4.11776C14.805 4.10659 14.8198 4.09213 14.8314 4.07521C14.843 4.05829 14.8512 4.03925 14.8554 4.01918L15.2296 2.25781C15.2345 2.23513 15.2342 2.21166 15.2289 2.1891C15.2235 2.16653 15.2132 2.14545 15.1986 2.12739C15.1841 2.10933 15.1657 2.09475 15.1448 2.0847C15.1239 2.07466 15.101 2.06941 15.0778 2.06933V2.06922ZM9.92889 2.35004C9.90806 2.34815 9.88708 2.3506 9.86725 2.35724C9.84773 2.36353 9.82964 2.37362 9.81403 2.38692C9.79842 2.40022 9.78559 2.41648 9.77627 2.43475C9.76696 2.45302 9.76134 2.47296 9.75975 2.49341C9.75816 2.51385 9.76063 2.53442 9.767 2.55391L10.001 3.27429C10.0073 3.29381 10.0174 3.3119 10.0307 3.32752C10.044 3.34314 10.0603 3.35597 10.0786 3.36528C10.0968 3.3746 10.1168 3.38021 10.1372 3.3818C10.1577 3.38338 10.1783 3.38092 10.1978 3.37453C10.2173 3.36824 10.2354 3.35814 10.251 3.34484C10.2666 3.33153 10.2794 3.31526 10.2888 3.29698C10.2981 3.2787 10.3037 3.25876 10.3053 3.23831C10.3068 3.21785 10.3044 3.19728 10.298 3.17779L10.0639 2.45745C10.0545 2.42823 10.0367 2.40244 10.0126 2.38333C9.98861 2.36423 9.95948 2.35264 9.92889 2.35004ZM16.0733 2.35041C16.0428 2.35302 16.0136 2.3646 15.9896 2.38371C15.9656 2.40282 15.9477 2.4286 15.9383 2.45782L15.7041 3.17812C15.6977 3.19762 15.6953 3.21818 15.6968 3.23863C15.6984 3.25908 15.704 3.27902 15.7134 3.29729C15.7227 3.31557 15.7355 3.33183 15.7511 3.34514C15.7667 3.35844 15.7848 3.36853 15.8043 3.37483C15.8238 3.38121 15.8444 3.38369 15.8648 3.3821C15.8853 3.38052 15.9052 3.37491 15.9235 3.36561C15.9418 3.3563 15.958 3.34347 15.9713 3.32787C15.9846 3.31226 15.9947 3.29418 16.001 3.27466L16.2352 2.55428C16.2416 2.53479 16.2441 2.51423 16.2425 2.49378C16.2409 2.47333 16.2353 2.4534 16.226 2.43512C16.2167 2.41684 16.2039 2.40058 16.1883 2.38728C16.1727 2.37397 16.1546 2.36387 16.1351 2.35757C16.1152 2.35109 16.0942 2.34866 16.0733 2.35041ZM8.93881 2.71238C8.91792 2.7128 8.89732 2.71741 8.87825 2.72596C8.85949 2.73425 8.84256 2.74617 8.82842 2.76102C8.81428 2.77587 8.80321 2.79337 8.79585 2.81251C8.78849 2.83165 8.78498 2.85206 8.78553 2.87256C8.78608 2.89306 8.79066 2.91325 8.79903 2.93198L9.53039 4.57741C9.53868 4.59617 9.55059 4.61311 9.56544 4.62725C9.5803 4.6414 9.5978 4.65246 9.61694 4.65983C9.63608 4.66719 9.65649 4.67069 9.67699 4.67015C9.69749 4.6696 9.71768 4.665 9.7364 4.65663C9.75517 4.64835 9.77211 4.63644 9.78626 4.62158C9.8004 4.60673 9.81148 4.58924 9.81885 4.57009C9.82621 4.55095 9.82973 4.53054 9.82919 4.51004C9.82865 4.48954 9.82406 4.46934 9.8157 4.45061L9.0843 2.80521C9.07191 2.77711 9.05148 2.75331 9.0256 2.73678C8.99971 2.72026 8.96952 2.71176 8.93881 2.71235V2.71238ZM17.0746 2.71787C17.0439 2.71728 17.0137 2.72576 16.9878 2.74224C16.9619 2.75871 16.9415 2.78246 16.929 2.81052L16.1954 4.45495C16.187 4.47367 16.1824 4.49386 16.1818 4.51436C16.1813 4.53486 16.1847 4.55527 16.1921 4.57443C16.1994 4.59358 16.2105 4.61109 16.2246 4.62596C16.2387 4.64083 16.2556 4.65277 16.2744 4.66108C16.2931 4.66947 16.3133 4.67409 16.3338 4.67466C16.3543 4.67523 16.3747 4.67174 16.3939 4.6644C16.413 4.65706 16.4305 4.64601 16.4454 4.63189C16.4603 4.61776 16.4722 4.60084 16.4805 4.58209L17.2141 2.93772C17.2225 2.91901 17.2271 2.89882 17.2277 2.87831C17.2283 2.8578 17.2248 2.83738 17.2174 2.81823C17.2101 2.79907 17.1991 2.78155 17.1849 2.76668C17.1708 2.75181 17.1539 2.73987 17.1351 2.73156C17.116 2.72302 17.0955 2.71836 17.0746 2.71787ZM8.01983 3.19859C7.98878 3.19636 7.95778 3.20357 7.9309 3.21929C7.91311 3.22951 7.89752 3.24314 7.88502 3.2594C7.87252 3.27566 7.86335 3.29423 7.85804 3.31405C7.85273 3.33386 7.85139 3.35453 7.85409 3.37486C7.8568 3.3952 7.86349 3.4148 7.87379 3.43254L8.25248 4.0885C8.2627 4.10628 8.27633 4.12187 8.29259 4.13438C8.30886 4.14688 8.32743 4.15605 8.34724 4.16136C8.36705 4.16666 8.38772 4.168 8.40806 4.1653C8.42839 4.1626 8.44799 4.15591 8.46573 4.14561C8.48352 4.13539 8.49911 4.12176 8.51161 4.1055C8.52411 4.08924 8.53328 4.07066 8.53859 4.05085C8.5439 4.03104 8.54524 4.01037 8.54253 3.99003C8.53983 3.9697 8.53314 3.9501 8.52284 3.93236L8.14419 3.27644C8.13145 3.25425 8.11345 3.23554 8.09176 3.22197C8.07008 3.20839 8.04539 3.20036 8.01987 3.19859H8.01983ZM17.981 3.19859C17.9554 3.20033 17.9307 3.20834 17.9091 3.22191C17.8874 3.23549 17.8694 3.2542 17.8567 3.2764L17.4779 3.93236C17.4677 3.9501 17.461 3.96971 17.4583 3.99005C17.4556 4.01038 17.4569 4.03105 17.4622 4.05087C17.4675 4.07068 17.4767 4.08925 17.4892 4.10551C17.5017 4.12177 17.5173 4.1354 17.5351 4.14561C17.5529 4.15591 17.5725 4.1626 17.5928 4.1653C17.6131 4.168 17.6338 4.16666 17.6536 4.16136C17.6734 4.15605 17.692 4.14688 17.7083 4.13438C17.7245 4.12187 17.7382 4.10628 17.7484 4.0885L18.1271 3.4325C18.1374 3.41476 18.1441 3.39516 18.1468 3.37483C18.1495 3.35449 18.1481 3.33382 18.1428 3.31401C18.1375 3.2942 18.1284 3.27563 18.1158 3.25936C18.1033 3.2431 18.0878 3.22947 18.07 3.21925C18.043 3.20363 18.012 3.19644 17.981 3.19859ZM7.12745 3.75516C7.09635 3.75628 7.06629 3.76665 7.04111 3.78494C7.02448 3.79695 7.01038 3.81213 6.99963 3.8296C6.98888 3.84707 6.98169 3.86649 6.97847 3.88675C6.97525 3.90701 6.97606 3.92771 6.98086 3.94765C6.98566 3.9676 6.99435 3.9864 7.00643 4.00297L8.06374 5.46049C8.07576 5.47712 8.09094 5.49121 8.10842 5.50196C8.12589 5.5127 8.14532 5.51989 8.16558 5.52312C8.18584 5.52634 8.20654 5.52553 8.22648 5.52073C8.24643 5.51594 8.26523 5.50725 8.28182 5.49517C8.29844 5.48316 8.31253 5.46798 8.32328 5.45052C8.33402 5.43305 8.34121 5.41363 8.34443 5.39337C8.34766 5.37312 8.34685 5.35243 8.34205 5.33249C8.33726 5.31254 8.32857 5.29375 8.31649 5.27717L7.25914 3.81965C7.24418 3.79892 7.22434 3.7822 7.20138 3.77095C7.17841 3.75971 7.15303 3.7543 7.12748 3.7552L7.12745 3.75516ZM18.8845 3.76309C18.859 3.76216 18.8336 3.76753 18.8106 3.77874C18.7876 3.78995 18.7678 3.80665 18.7528 3.82737L17.6935 5.28348C17.6814 5.30004 17.6727 5.31883 17.6679 5.33877C17.663 5.35871 17.6622 5.3794 17.6654 5.39966C17.6686 5.41992 17.6758 5.43936 17.6865 5.45684C17.6972 5.47432 17.7113 5.48952 17.7279 5.50155C17.7445 5.51365 17.7633 5.52236 17.7832 5.52719C17.8031 5.53201 17.8238 5.53285 17.8441 5.52966C17.8643 5.52647 17.8838 5.51931 17.9013 5.50859C17.9187 5.49788 17.9339 5.48381 17.946 5.46721L19.0052 4.01113C19.0173 3.99457 19.026 3.97578 19.0309 3.95584C19.0357 3.9359 19.0365 3.91521 19.0333 3.89495C19.0301 3.87469 19.0229 3.85526 19.0122 3.83777C19.0015 3.82029 18.9874 3.80509 18.9708 3.79306C18.9457 3.77468 18.9156 3.76424 18.8845 3.76309ZM6.32982 4.4241C6.30933 4.42299 6.28882 4.42596 6.26949 4.43284C6.25015 4.43971 6.23237 4.45035 6.21718 4.46415C6.20191 4.47784 6.18949 4.49441 6.18064 4.51292C6.17179 4.53142 6.16668 4.55149 6.16561 4.57197C6.16453 4.59245 6.16751 4.61294 6.17438 4.63227C6.18124 4.6516 6.19186 4.66938 6.20561 4.6846L6.71241 5.24758C6.7261 5.26285 6.74267 5.27527 6.76117 5.28412C6.77968 5.29297 6.79975 5.29808 6.82023 5.29915C6.84071 5.30022 6.86121 5.29724 6.88054 5.29036C6.89986 5.28349 6.91764 5.27287 6.93285 5.25911C6.94812 5.24542 6.96054 5.22884 6.96939 5.21033C6.97825 5.19183 6.98336 5.17176 6.98443 5.15127C6.98551 5.13079 6.98253 5.11029 6.97566 5.09096C6.96879 5.07163 6.95818 5.05385 6.94442 5.03863L6.4377 4.47568C6.42401 4.4604 6.40744 4.44798 6.38893 4.43912C6.37042 4.43027 6.35034 4.42516 6.32985 4.4241H6.32982ZM19.6721 4.42521C19.6307 4.42743 19.5919 4.446 19.5642 4.47683L19.0575 5.03967C19.0437 5.05488 19.0331 5.07266 19.0262 5.09199C19.0193 5.11132 19.0163 5.13182 19.0174 5.15231C19.0185 5.17281 19.0236 5.19288 19.0324 5.2114C19.0413 5.22991 19.0537 5.24649 19.069 5.26019C19.0842 5.27395 19.102 5.28457 19.1213 5.29143C19.1406 5.2983 19.1611 5.30129 19.1816 5.30021C19.2021 5.29913 19.2222 5.29402 19.2407 5.28517C19.2592 5.27631 19.2758 5.26389 19.2895 5.24861L19.7963 4.68578C19.81 4.67056 19.8207 4.65277 19.8275 4.63344C19.8344 4.61411 19.8374 4.59361 19.8363 4.57312C19.8352 4.55263 19.8301 4.53256 19.8213 4.51405C19.8124 4.49554 19.8 4.47896 19.7847 4.46526C19.7695 4.4515 19.7518 4.44087 19.7324 4.434C19.7131 4.42712 19.6926 4.42414 19.6722 4.42521H19.6721ZM5.56534 5.15842C5.54486 5.15952 5.5248 5.16465 5.5063 5.17351C5.4878 5.18236 5.47123 5.19478 5.45753 5.21004C5.44377 5.22526 5.43315 5.24304 5.42628 5.26237C5.41941 5.2817 5.41643 5.3022 5.41751 5.32269C5.41858 5.34318 5.42369 5.36325 5.43255 5.38175C5.4414 5.40026 5.45382 5.41683 5.4691 5.43053L6.80739 6.63522C6.8226 6.64898 6.84038 6.65959 6.85971 6.66646C6.87904 6.67332 6.89953 6.6763 6.92001 6.67523C6.94049 6.67415 6.96056 6.66904 6.97906 6.66019C6.99757 6.65134 7.01414 6.63892 7.02783 6.62365C7.04159 6.60844 7.05221 6.59066 7.05908 6.57134C7.06596 6.55201 7.06894 6.53152 7.06787 6.51103C7.0668 6.49055 7.06169 6.47048 7.05284 6.45197C7.04399 6.43347 7.03157 6.4169 7.0163 6.40321L5.67798 5.19851C5.66276 5.18474 5.64497 5.17411 5.62564 5.16723C5.6063 5.16036 5.5858 5.15738 5.5653 5.15846L5.56534 5.15842ZM20.4403 5.16372C20.4198 5.1626 20.3993 5.16555 20.3799 5.17241C20.3606 5.17926 20.3428 5.18989 20.3276 5.20366L18.9885 6.40743C18.9732 6.42111 18.9608 6.43767 18.9519 6.45617C18.9431 6.47466 18.9379 6.49472 18.9368 6.51521C18.9357 6.53569 18.9387 6.55619 18.9456 6.57552C18.9524 6.59486 18.963 6.61265 18.9767 6.62788C18.9904 6.64316 19.007 6.6556 19.0255 6.66446C19.044 6.67333 19.0641 6.67845 19.0846 6.67954C19.1051 6.68063 19.1256 6.67766 19.1449 6.67081C19.1642 6.66395 19.182 6.65335 19.1973 6.6396L20.5364 5.43583C20.5517 5.42215 20.5641 5.40558 20.573 5.38709C20.5818 5.36859 20.587 5.34852 20.5881 5.32804C20.5891 5.30756 20.5862 5.28706 20.5793 5.26773C20.5725 5.2484 20.5619 5.23061 20.5481 5.21538C20.5344 5.20009 20.5179 5.18766 20.4994 5.17879C20.4809 5.16993 20.4608 5.1648 20.4403 5.16372ZM4.9296 5.97593C4.90404 5.975 4.87866 5.98039 4.85568 5.99162C4.83271 6.00285 4.81286 6.01958 4.7979 6.04031C4.7858 6.05688 4.77709 6.07568 4.77228 6.09562C4.76747 6.11557 4.76664 6.13627 4.76986 6.15653C4.77307 6.1768 4.78025 6.19622 4.791 6.2137C4.80174 6.23118 4.81583 6.24637 4.83247 6.25838L5.44522 6.70354C5.46178 6.71564 5.48057 6.72435 5.50051 6.72917C5.52045 6.73399 5.54114 6.73482 5.5614 6.73161C5.58166 6.72841 5.60109 6.72123 5.61857 6.71049C5.63605 6.69976 5.65123 6.68567 5.66325 6.66905C5.67535 6.65248 5.68405 6.63368 5.68886 6.61374C5.69368 6.5938 5.6945 6.57311 5.6913 6.55285C5.68809 6.53259 5.68092 6.51316 5.67019 6.49567C5.65946 6.47819 5.64538 6.463 5.62876 6.45097L5.01597 6.00578C4.99081 5.98743 4.96072 5.97703 4.9296 5.97593ZM21.0754 5.9816C21.0443 5.98271 21.0143 5.99308 20.9891 6.01138L20.376 6.45617C20.3594 6.46818 20.3453 6.48336 20.3346 6.50083C20.3238 6.51831 20.3166 6.53773 20.3134 6.55799C20.3102 6.57825 20.311 6.59895 20.3158 6.6189C20.3206 6.63885 20.3292 6.65765 20.3413 6.67424C20.3533 6.69087 20.3685 6.70496 20.386 6.71571C20.4035 6.72646 20.4229 6.73365 20.4431 6.73688C20.4634 6.7401 20.4841 6.73928 20.504 6.73449C20.524 6.72969 20.5428 6.721 20.5594 6.70891L21.1724 6.26409C21.1891 6.25208 21.2031 6.2369 21.2139 6.21943C21.2246 6.20196 21.2318 6.18254 21.235 6.16229C21.2383 6.14203 21.2374 6.12134 21.2326 6.1014C21.2278 6.08146 21.2192 6.06267 21.2071 6.0461C21.1921 6.02536 21.1723 6.00863 21.1493 5.99738C21.1264 5.98613 21.101 5.98071 21.0754 5.9816ZM4.33554 6.84788C4.31002 6.84962 4.28533 6.85763 4.26366 6.8712C4.24199 6.88478 4.224 6.90349 4.2113 6.92569C4.201 6.94343 4.19431 6.96303 4.1916 6.98336C4.1889 7.0037 4.19024 7.02436 4.19555 7.04418C4.20086 7.06399 4.21003 7.08256 4.22253 7.09882C4.23503 7.11509 4.25062 7.12872 4.26841 7.13894L5.82781 8.03926C5.84555 8.04956 5.86515 8.05625 5.88548 8.05895C5.90581 8.06166 5.92648 8.06031 5.9463 8.05501C5.96611 8.0497 5.98468 8.04053 6.00094 8.02803C6.01721 8.01553 6.03084 7.99993 6.04106 7.98215C6.05135 7.96441 6.05805 7.94481 6.06075 7.92447C6.06345 7.90414 6.06211 7.88347 6.0568 7.86366C6.05149 7.84384 6.04233 7.82527 6.02982 7.80901C6.01732 7.79275 6.00173 7.77912 5.98394 7.7689L4.42455 6.86857C4.39761 6.85294 4.36661 6.84574 4.33554 6.84788ZM21.6653 6.84788C21.6342 6.84565 21.6032 6.85286 21.5763 6.86857L20.017 7.7689C19.9992 7.77912 19.9836 7.79275 19.9711 7.80901C19.9586 7.82527 19.9494 7.84384 19.9441 7.86366C19.9388 7.88347 19.9375 7.90414 19.9402 7.92447C19.9429 7.94481 19.9495 7.96441 19.9598 7.98215C19.9701 7.99993 19.9837 8.01553 20 8.02803C20.0162 8.04053 20.0348 8.0497 20.0546 8.05501C20.0744 8.06031 20.0951 8.06166 20.1154 8.05895C20.1358 8.05625 20.1554 8.04956 20.1731 8.03926L21.7325 7.13898C21.7503 7.12876 21.7659 7.11512 21.7784 7.09886C21.7909 7.0826 21.8001 7.06403 21.8054 7.04422C21.8107 7.0244 21.812 7.00373 21.8093 6.9834C21.8066 6.96307 21.7999 6.94347 21.7896 6.92573C21.7769 6.90355 21.7589 6.88485 21.7372 6.87127C21.7155 6.8577 21.6908 6.84968 21.6653 6.84792V6.84788ZM3.8863 7.77732C3.8556 7.77664 3.82539 7.78508 3.79949 7.80156C3.77358 7.81804 3.75314 7.84183 3.74074 7.86992C3.73234 7.88864 3.72772 7.90883 3.72714 7.92933C3.72657 7.94984 3.73005 7.97025 3.73738 7.98941C3.74472 8.00857 3.75577 8.02608 3.76989 8.04096C3.78402 8.05583 3.80094 8.06777 3.81969 8.07609L4.51148 8.38465C4.53019 8.39305 4.55038 8.39767 4.57089 8.39825C4.59139 8.39882 4.61181 8.39534 4.63096 8.38801C4.65012 8.38067 4.66764 8.36962 4.68251 8.3555C4.69739 8.34137 4.70933 8.32445 4.71764 8.3057C4.72604 8.28698 4.73066 8.26679 4.73123 8.24628C4.73181 8.22577 4.72832 8.20536 4.72098 8.1862C4.71364 8.16704 4.70259 8.14952 4.68846 8.13465C4.67433 8.11978 4.6574 8.10784 4.63865 8.09953L3.9469 7.79097C3.92782 7.7824 3.90721 7.77777 3.8863 7.77735V7.77732ZM22.1175 7.78377C22.0966 7.7842 22.076 7.78882 22.0569 7.79738L21.365 8.10543C21.3462 8.11372 21.3293 8.12564 21.3151 8.1405C21.301 8.15536 21.2899 8.17287 21.2826 8.19202C21.2752 8.21117 21.2717 8.23158 21.2722 8.25209C21.2728 8.2726 21.2774 8.29279 21.2858 8.31152C21.2941 8.33028 21.306 8.34722 21.3209 8.36136C21.3358 8.3755 21.3533 8.38656 21.3724 8.39391C21.3916 8.40127 21.412 8.40476 21.4325 8.40421C21.4531 8.40365 21.4733 8.39904 21.492 8.39066L22.1839 8.08258C22.2026 8.07428 22.2196 8.06235 22.2337 8.04749C22.2478 8.03262 22.2589 8.01512 22.2662 7.99597C22.2736 7.97682 22.2771 7.95641 22.2765 7.9359C22.276 7.9154 22.2714 7.89521 22.263 7.87649C22.2506 7.84842 22.2302 7.82464 22.2043 7.80814C22.1784 7.79165 22.1482 7.78317 22.1175 7.78377ZM3.48598 8.74877C3.45541 8.75135 3.42627 8.7629 3.40224 8.78198C3.3782 8.80107 3.36035 8.82683 3.35091 8.85603C3.34452 8.87552 3.34203 8.89607 3.3436 8.91652C3.34517 8.93698 3.35076 8.95691 3.36005 8.9752C3.36934 8.99348 3.38216 9.00975 3.39775 9.02307C3.41335 9.03639 3.43142 9.0465 3.45094 9.05281L5.16298 9.61067C5.18248 9.61708 5.20304 9.61957 5.2235 9.618C5.24395 9.61643 5.2639 9.61084 5.28219 9.60154C5.30047 9.59224 5.31675 9.57942 5.33007 9.56382C5.34339 9.54822 5.35349 9.53014 5.35981 9.51061C5.3662 9.49113 5.36869 9.47056 5.36712 9.45011C5.36555 9.42966 5.35995 9.40972 5.35066 9.39144C5.34136 9.37315 5.32854 9.35688 5.31294 9.34357C5.29734 9.33025 5.27926 9.32014 5.25974 9.31383L3.5477 8.75593C3.52782 8.74942 3.50683 8.74698 3.48598 8.74874V8.74877ZM22.5171 8.75545C22.4963 8.75356 22.4753 8.75601 22.4555 8.76264L20.743 9.31928C20.7235 9.32558 20.7054 9.33568 20.6898 9.34899C20.6742 9.3623 20.6614 9.37856 20.652 9.39684C20.6427 9.41512 20.6371 9.43506 20.6356 9.45552C20.634 9.47597 20.6364 9.49654 20.6428 9.51603C20.6491 9.53555 20.6592 9.55363 20.6726 9.56924C20.6859 9.58484 20.7021 9.59766 20.7204 9.60697C20.7387 9.61627 20.7586 9.62188 20.7791 9.62345C20.7995 9.62503 20.8201 9.62255 20.8396 9.61616L22.552 9.05956C22.5715 9.05326 22.5896 9.04317 22.6052 9.02986C22.6208 9.01656 22.6336 9.0003 22.643 8.98201C22.6523 8.96373 22.6579 8.94379 22.6595 8.92334C22.6611 8.90288 22.6586 8.88232 22.6522 8.86282C22.6428 8.83359 22.6249 8.80781 22.6009 8.7887C22.5768 8.76959 22.5477 8.75801 22.5171 8.75541V8.75545ZM3.23657 9.76844C3.20061 9.76815 3.16564 9.78031 3.13763 9.80287C3.10961 9.82543 3.09027 9.857 3.08289 9.8922C3.07858 9.91226 3.07828 9.93297 3.082 9.95314C3.08572 9.97332 3.09338 9.99256 3.10456 10.0098C3.11573 10.027 3.1302 10.0418 3.14712 10.0534C3.16404 10.065 3.18308 10.0731 3.20316 10.0773L3.94405 10.2348C3.9641 10.2391 3.98481 10.2394 4.00499 10.2357C4.02516 10.232 4.0444 10.2243 4.0616 10.2131C4.07881 10.202 4.09363 10.1875 4.10523 10.1706C4.11683 10.1537 4.12497 10.1346 4.12918 10.1145C4.13349 10.0945 4.1338 10.0738 4.13008 10.0536C4.12636 10.0334 4.1187 10.0142 4.10753 9.99699C4.09635 9.97979 4.08189 9.96496 4.06498 9.95337C4.04806 9.94177 4.02902 9.93362 4.00895 9.9294L3.2681 9.77193C3.25773 9.76973 3.24717 9.76861 3.23657 9.76859V9.76844ZM22.7646 9.76993C22.754 9.77017 22.7435 9.77129 22.7331 9.77326L21.9922 9.93066C21.9721 9.93488 21.9531 9.94302 21.9362 9.95461C21.9193 9.9662 21.9048 9.98102 21.8937 9.99822C21.8825 10.0154 21.8748 10.0346 21.8711 10.0548C21.8674 10.075 21.8677 10.0957 21.872 10.1157C21.8762 10.1358 21.8843 10.1549 21.8959 10.1718C21.9075 10.1887 21.9224 10.2032 21.9396 10.2143C21.9568 10.2255 21.976 10.2332 21.9962 10.2369C22.0163 10.2407 22.0371 10.2404 22.0571 10.2361L22.798 10.0787C22.818 10.0745 22.8371 10.0663 22.854 10.0547C22.8709 10.0431 22.8854 10.0283 22.8966 10.0111C22.9077 9.99389 22.9154 9.97465 22.9191 9.95448C22.9229 9.93431 22.9226 9.9136 22.9183 9.89354C22.9109 9.85834 22.8915 9.82679 22.8635 9.80424C22.8355 9.78168 22.8006 9.76951 22.7646 9.76978V9.76993ZM3.04776 10.7942C3.01198 10.7976 2.9785 10.8133 2.95299 10.8387C2.92749 10.864 2.91153 10.8974 2.90784 10.9331C2.90563 10.9535 2.90747 10.9742 2.91326 10.9938C2.91904 11.0135 2.92866 11.0319 2.94156 11.0478C2.95446 11.0638 2.97038 11.077 2.98842 11.0868C3.00645 11.0966 3.02624 11.1027 3.04665 11.1048L4.83729 11.2941C4.85769 11.2963 4.87832 11.2945 4.89801 11.2887C4.9177 11.2829 4.93605 11.2733 4.952 11.2604C4.96796 11.2475 4.98121 11.2316 4.99099 11.2135C5.00077 11.1955 5.00689 11.1757 5.009 11.1553C5.0112 11.1349 5.00936 11.1142 5.00356 11.0946C4.99777 11.0749 4.98814 11.0565 4.97523 11.0406C4.96233 11.0246 4.9464 11.0114 4.92836 11.0016C4.91031 10.9918 4.89052 10.9857 4.87011 10.9836L3.07944 10.7943C3.06891 10.7932 3.0583 10.7931 3.04776 10.7942ZM22.9547 10.8076C22.9441 10.8065 22.9335 10.8065 22.9229 10.8077L21.1321 10.9947C21.1117 10.9967 21.0919 11.0028 21.0738 11.0126C21.0558 11.0223 21.0399 11.0356 21.0269 11.0515C21.014 11.0674 21.0044 11.0857 20.9985 11.1054C20.9927 11.1251 20.9908 11.1457 20.993 11.1661C20.9951 11.1865 21.0012 11.2063 21.0109 11.2244C21.0207 11.2424 21.0339 11.2584 21.0499 11.2713C21.0658 11.2842 21.0841 11.2938 21.1038 11.2997C21.1235 11.3055 21.1441 11.3074 21.1645 11.3052L22.9554 11.1183C22.9758 11.1162 22.9956 11.1101 23.0136 11.1003C23.0317 11.0906 23.0476 11.0774 23.0605 11.0614C23.0734 11.0455 23.0831 11.0272 23.0889 11.0075C23.0947 10.9878 23.0966 10.9672 23.0944 10.9468C23.0908 10.911 23.0749 10.8776 23.0494 10.8522C23.0239 10.8269 22.9905 10.8111 22.9547 10.8076V10.8076ZM3.01746 11.8441C2.99695 11.844 2.97662 11.848 2.95766 11.8559C2.93869 11.8637 2.92146 11.8752 2.90695 11.8897C2.89244 11.9042 2.88094 11.9215 2.87311 11.9404C2.86528 11.9594 2.86128 11.9797 2.86133 12.0002C2.86129 12.0207 2.8653 12.0411 2.87314 12.06C2.88097 12.079 2.89247 12.0962 2.90698 12.1107C2.92148 12.1252 2.93871 12.1367 2.95767 12.1445C2.97663 12.1523 2.99695 12.1563 3.01746 12.1563H3.77489C3.79541 12.1563 3.81573 12.1523 3.83469 12.1445C3.85365 12.1367 3.87088 12.1252 3.88538 12.1107C3.89989 12.0962 3.91139 12.0789 3.91922 12.06C3.92706 12.041 3.93107 12.0207 3.93103 12.0002C3.93107 11.9797 3.92706 11.9594 3.91923 11.9404C3.9114 11.9214 3.8999 11.9042 3.8854 11.8897C3.87089 11.8752 3.85366 11.8637 3.8347 11.8558C3.81573 11.848 3.79541 11.844 3.77489 11.8441L3.01746 11.8441ZM22.2259 11.8441C22.2054 11.844 22.1851 11.848 22.1661 11.8559C22.1472 11.8637 22.1299 11.8752 22.1154 11.8897C22.1009 11.9042 22.0894 11.9215 22.0816 11.9404C22.0738 11.9594 22.0697 11.9797 22.0698 12.0002C22.0698 12.0207 22.0738 12.0411 22.0816 12.06C22.0894 12.079 22.1009 12.0962 22.1154 12.1107C22.13 12.1252 22.1472 12.1367 22.1661 12.1445C22.1851 12.1523 22.2054 12.1563 22.2259 12.1563H22.9834C23.0039 12.1563 23.0242 12.1523 23.0432 12.1445C23.0621 12.1367 23.0793 12.1252 23.0938 12.1107C23.1083 12.0962 23.1198 12.0789 23.1277 12.06C23.1355 12.041 23.1395 12.0207 23.1395 12.0002C23.1395 11.9797 23.1355 11.9593 23.1277 11.9404C23.1198 11.9214 23.1083 11.9042 23.0938 11.8897C23.0793 11.8752 23.0621 11.8637 23.0431 11.8558C23.0242 11.848 23.0038 11.844 22.9833 11.8441L22.2259 11.8441ZM4.868 12.6951C4.85746 12.6939 4.84684 12.694 4.83632 12.6952L3.04539 12.8821C3.02498 12.8842 3.00519 12.8903 2.98714 12.9C2.9691 12.9098 2.95316 12.923 2.94023 12.9389C2.92731 12.9548 2.91766 12.9732 2.91184 12.9928C2.90602 13.0125 2.90414 13.0331 2.90632 13.0535C2.9084 13.0739 2.91449 13.0937 2.92424 13.1118C2.934 13.1298 2.94722 13.1458 2.96315 13.1587C2.97908 13.1716 2.99741 13.1813 3.01708 13.1871C3.03675 13.1929 3.05737 13.1948 3.07777 13.1926L4.8687 13.0057C4.88911 13.0036 4.9089 12.9975 4.92695 12.9878C4.94499 12.978 4.96093 12.9648 4.97386 12.9489C4.98678 12.9329 4.99643 12.9146 5.00225 12.8949C5.00807 12.8753 5.00995 12.8546 5.00778 12.8342C5.00412 12.7985 4.9882 12.7651 4.96271 12.7397C4.93723 12.7143 4.90375 12.6985 4.86796 12.6951H4.868ZM21.1318 12.7061C21.096 12.7096 21.0625 12.7253 21.037 12.7506C21.0115 12.776 20.9956 12.8093 20.9919 12.8451C20.9897 12.8655 20.9915 12.8861 20.9973 12.9058C21.0031 12.9255 21.0127 12.9438 21.0256 12.9598C21.0385 12.9757 21.0544 12.989 21.0724 12.9988C21.0905 13.0085 21.1102 13.0147 21.1306 13.0168L22.9213 13.2061C22.9417 13.2083 22.9623 13.2064 22.982 13.2006C23.0017 13.1948 23.0201 13.1852 23.036 13.1723C23.052 13.1594 23.0652 13.1435 23.075 13.1255C23.0848 13.1074 23.0909 13.0876 23.093 13.0672C23.0952 13.0468 23.0933 13.0262 23.0875 13.0065C23.0818 12.9868 23.0721 12.9685 23.0592 12.9526C23.0463 12.9366 23.0304 12.9234 23.0124 12.9136C22.9943 12.9038 22.9745 12.8977 22.9541 12.8956L21.1635 12.7063C21.153 12.7052 21.1424 12.7051 21.1318 12.7061ZM3.97531 13.7607C3.96472 13.7608 3.95416 13.7619 3.94379 13.7641L3.2029 13.9215C3.18282 13.9257 3.16378 13.9338 3.14686 13.9454C3.12994 13.957 3.11547 13.9719 3.1043 13.9891C3.09312 14.0063 3.08546 14.0255 3.08174 14.0457C3.07802 14.0659 3.07832 14.0866 3.08263 14.1066C3.08684 14.1267 3.09498 14.1457 3.10658 14.1627C3.11818 14.1796 3.13301 14.194 3.15021 14.2052C3.16741 14.2164 3.18665 14.2241 3.20682 14.2278C3.227 14.2315 3.24771 14.2312 3.26777 14.2269L4.00869 14.0696C4.02876 14.0653 4.0478 14.0572 4.06472 14.0456C4.08164 14.034 4.09609 14.0192 4.10727 14.002C4.11844 13.9848 4.1261 13.9655 4.12982 13.9454C4.13354 13.9252 4.13323 13.9045 4.12892 13.8844C4.12155 13.8492 4.10222 13.8177 4.07422 13.7951C4.04622 13.7725 4.01127 13.7604 3.97531 13.7606V13.7607ZM22.0253 13.7622C21.9893 13.7619 21.9544 13.7741 21.9264 13.7966C21.8984 13.8192 21.879 13.8507 21.8717 13.8859C21.8674 13.906 21.867 13.9267 21.8708 13.9468C21.8745 13.967 21.8821 13.9863 21.8933 14.0035C21.9044 14.0207 21.9189 14.0355 21.9358 14.0471C21.9527 14.0587 21.9718 14.0669 21.9918 14.0711L22.7328 14.2285C22.7528 14.2328 22.7735 14.2332 22.7937 14.2295C22.8139 14.2257 22.8331 14.2181 22.8503 14.2069C22.8675 14.1958 22.8824 14.1813 22.894 14.1644C22.9056 14.1475 22.9137 14.1284 22.9179 14.1084C22.9223 14.0883 22.9226 14.0676 22.9188 14.0474C22.9151 14.0272 22.9075 14.008 22.8963 13.9908C22.8851 13.9735 22.8706 13.9587 22.8537 13.9471C22.8368 13.9355 22.8177 13.9273 22.7977 13.9231L22.0568 13.7657C22.0465 13.7635 22.0359 13.7624 22.0253 13.7623V13.7622ZM5.22292 14.3771C5.20209 14.3752 5.18111 14.3777 5.16128 14.3843L3.44882 14.9409C3.42931 14.9472 3.41122 14.9573 3.39562 14.9706C3.38001 14.9839 3.36718 15.0002 3.35788 15.0185C3.34857 15.0368 3.34296 15.0567 3.34138 15.0771C3.3398 15.0976 3.34227 15.1181 3.34865 15.1376C3.35495 15.1572 3.36504 15.1752 3.37835 15.1909C3.39165 15.2065 3.40791 15.2193 3.42619 15.2286C3.44447 15.2379 3.4644 15.2435 3.48485 15.2451C3.5053 15.2467 3.52587 15.2442 3.54536 15.2378L5.25774 14.6812C5.27726 14.6749 5.29535 14.6648 5.31096 14.6515C5.32658 14.6382 5.33941 14.6219 5.34872 14.6036C5.35803 14.5854 5.36365 14.5654 5.36524 14.545C5.36683 14.5245 5.36436 14.504 5.35799 14.4845C5.34856 14.4552 5.33071 14.4295 5.30668 14.4104C5.28265 14.3912 5.25351 14.3797 5.22292 14.3771V14.3771ZM20.7761 14.3826C20.7456 14.3852 20.7164 14.3967 20.6924 14.4158C20.6683 14.4349 20.6505 14.4607 20.6411 14.4899C20.6347 14.5094 20.6322 14.5299 20.6337 14.5504C20.6353 14.5708 20.6409 14.5908 20.6502 14.6091C20.6595 14.6273 20.6723 14.6436 20.6879 14.6569C20.7035 14.6702 20.7216 14.6803 20.7411 14.6867L22.4531 15.2445C22.4726 15.2509 22.4932 15.2534 22.5136 15.2518C22.5341 15.2503 22.554 15.2447 22.5723 15.2354C22.5906 15.2261 22.6069 15.2133 22.6202 15.1977C22.6335 15.1821 22.6436 15.164 22.65 15.1445C22.6563 15.125 22.6588 15.1044 22.6573 15.084C22.6557 15.0635 22.6501 15.0436 22.6408 15.0253C22.6315 15.007 22.6187 14.9907 22.6031 14.9774C22.5875 14.9641 22.5694 14.954 22.5499 14.9477L20.8378 14.3898C20.818 14.3833 20.797 14.3809 20.7761 14.3826ZM4.56948 15.5963C4.54858 15.5967 4.52797 15.6013 4.50888 15.6098L3.81687 15.9179C3.79812 15.9262 3.7812 15.9381 3.76707 15.953C3.75293 15.9679 3.74188 15.9854 3.73453 16.0045C3.72719 16.0237 3.72369 16.0441 3.72426 16.0646C3.72482 16.0851 3.72942 16.1053 3.73781 16.124C3.74611 16.1428 3.75803 16.1597 3.7729 16.1738C3.78776 16.188 3.80527 16.199 3.82442 16.2064C3.84357 16.2137 3.86398 16.2172 3.88448 16.2167C3.90499 16.2161 3.92518 16.2115 3.9439 16.2031L4.6359 15.8951C4.65466 15.8868 4.67158 15.8748 4.68571 15.86C4.69984 15.8451 4.7109 15.8276 4.71825 15.8084C4.72559 15.7893 4.72909 15.7689 4.72852 15.7484C4.72796 15.7279 4.72336 15.7077 4.71497 15.689C4.70255 15.6609 4.68211 15.6371 4.65622 15.6206C4.63033 15.6041 4.60014 15.5956 4.56944 15.5963L4.56948 15.5963ZM21.4288 15.6022C21.3981 15.6015 21.3679 15.61 21.342 15.6264C21.316 15.6429 21.2956 15.6667 21.2832 15.6948C21.2748 15.7135 21.2702 15.7337 21.2696 15.7542C21.269 15.7747 21.2725 15.7951 21.2798 15.8143C21.2872 15.8334 21.2982 15.851 21.3124 15.8658C21.3265 15.8807 21.3434 15.8926 21.3622 15.901L22.0539 16.2095C22.0726 16.2179 22.0928 16.2226 22.1133 16.2231C22.1338 16.2237 22.1542 16.2202 22.1734 16.2129C22.1925 16.2055 22.2101 16.1945 22.2249 16.1804C22.2398 16.1662 22.2517 16.1493 22.2601 16.1305C22.2684 16.1118 22.2731 16.0916 22.2736 16.0711C22.2742 16.0506 22.2707 16.0302 22.2634 16.0111C22.256 15.9919 22.245 15.9744 22.2309 15.9595C22.2167 15.9446 22.1998 15.9327 22.1811 15.9244L21.4894 15.6158C21.4703 15.6073 21.4497 15.6026 21.4288 15.6022ZM5.91674 15.9405C5.88566 15.9383 5.85464 15.9455 5.82773 15.9612L4.26837 16.8615C4.25059 16.8717 4.23499 16.8854 4.22249 16.9016C4.20999 16.9179 4.20082 16.9365 4.19551 16.9563C4.19021 16.9761 4.18887 16.9968 4.19157 17.0171C4.19427 17.0374 4.20096 17.057 4.21126 17.0748C4.22148 17.0925 4.23511 17.1081 4.25137 17.1206C4.26763 17.1331 4.28619 17.1423 4.306 17.1476C4.32581 17.1529 4.34648 17.1543 4.36681 17.1516C4.38714 17.1489 4.40673 17.1422 4.42447 17.1319L5.98383 16.2316C6.00161 16.2214 6.0172 16.2078 6.0297 16.1915C6.04221 16.1752 6.05137 16.1567 6.05668 16.1368C6.06199 16.117 6.06333 16.0964 6.06063 16.076C6.05793 16.0557 6.05124 16.0361 6.04095 16.0183C6.02822 15.9962 6.01023 15.9775 5.98856 15.9639C5.96689 15.9503 5.94221 15.9423 5.9167 15.9405H5.91674ZM20.0841 15.9405C20.0586 15.9422 20.0339 15.9502 20.0122 15.9638C19.9905 15.9774 19.9725 15.9961 19.9598 16.0183C19.9495 16.0361 19.9428 16.0557 19.9401 16.076C19.9374 16.0963 19.9387 16.117 19.944 16.1368C19.9493 16.1567 19.9585 16.1752 19.971 16.1915C19.9835 16.2078 19.9991 16.2214 20.0169 16.2316L21.5763 17.1319C21.594 17.1422 21.6136 17.1489 21.634 17.1516C21.6543 17.1543 21.675 17.1529 21.6948 17.1476C21.7146 17.1423 21.7332 17.1331 21.7494 17.1206C21.7657 17.1081 21.7793 17.0926 21.7896 17.0748C21.7999 17.057 21.8066 17.0374 21.8093 17.0171C21.812 16.9968 21.8106 16.9761 21.8053 16.9563C21.8 16.9365 21.7908 16.9179 21.7783 16.9016C21.7658 16.8854 21.7502 16.8717 21.7325 16.8615L20.173 15.9612C20.1461 15.9456 20.1151 15.9384 20.0841 15.9405ZM5.52781 17.2617C5.49667 17.2628 5.46658 17.2732 5.4414 17.2916L4.82835 17.7364C4.81172 17.7484 4.79762 17.7635 4.78688 17.781C4.77613 17.7985 4.76893 17.8179 4.76571 17.8382C4.76249 17.8584 4.7633 17.8791 4.7681 17.8991C4.7729 17.919 4.78159 17.9378 4.79367 17.9544C4.80568 17.971 4.82086 17.9851 4.83833 17.9959C4.8558 18.0066 4.87521 18.0138 4.89547 18.017C4.91572 18.0202 4.93641 18.0194 4.95636 18.0146C4.9763 18.0098 4.99509 18.0012 5.01167 17.9891L5.62479 17.5443C5.64142 17.5322 5.65551 17.5171 5.66626 17.4996C5.67701 17.4821 5.68421 17.4627 5.68743 17.4425C5.69066 17.4222 5.68985 17.4015 5.68506 17.3816C5.68027 17.3616 5.67158 17.3428 5.65951 17.3263C5.64453 17.3055 5.62468 17.2888 5.60171 17.2775C5.57873 17.2663 5.55334 17.2608 5.52777 17.2617H5.52781ZM20.4692 17.267C20.4437 17.2661 20.4183 17.2715 20.3953 17.2827C20.3724 17.2939 20.3525 17.3106 20.3375 17.3314C20.3254 17.3479 20.3167 17.3667 20.3119 17.3867C20.3071 17.4066 20.3063 17.4273 20.3095 17.4476C20.3127 17.4679 20.3199 17.4873 20.3306 17.5048C20.3414 17.5222 20.3555 17.5374 20.3721 17.5494L20.9849 17.9947C21.0014 18.0068 21.0202 18.0155 21.0402 18.0203C21.0601 18.0251 21.0808 18.0259 21.1011 18.0227C21.1213 18.0195 21.1407 18.0123 21.1582 18.0016C21.1757 17.9908 21.1909 17.9767 21.2029 17.9601C21.215 17.9435 21.2237 17.9248 21.2285 17.9048C21.2333 17.8849 21.2341 17.8642 21.2309 17.8439C21.2277 17.8237 21.2205 17.8043 21.2098 17.7868C21.1991 17.7693 21.185 17.7541 21.1684 17.7421L20.5556 17.2969C20.5305 17.2785 20.5004 17.2681 20.4692 17.267V17.267ZM6.91624 17.3209C6.89575 17.3198 6.87524 17.3227 6.8559 17.3296C6.83656 17.3364 6.81877 17.347 6.80357 17.3608L5.46446 18.5646C5.44918 18.5783 5.43675 18.5948 5.42789 18.6133C5.41902 18.6318 5.4139 18.6519 5.41281 18.6724C5.41172 18.6929 5.41469 18.7134 5.42154 18.7327C5.4284 18.752 5.439 18.7698 5.45275 18.785C5.46643 18.8003 5.48299 18.8127 5.50149 18.8216C5.51999 18.8305 5.54005 18.8356 5.56053 18.8367C5.58102 18.8378 5.60151 18.8348 5.62085 18.828C5.64018 18.8211 5.65797 18.8105 5.67319 18.7968L7.01229 17.593C7.02757 17.5793 7.04 17.5627 7.04887 17.5442C7.05773 17.5257 7.06286 17.5057 7.06394 17.4852C7.06503 17.4647 7.06207 17.4442 7.05521 17.4249C7.04836 17.4056 7.03776 17.3878 7.02401 17.3725C7.01034 17.3572 6.99378 17.3448 6.97528 17.3359C6.95678 17.3271 6.93672 17.322 6.91624 17.3209ZM19.0808 17.3252C19.0394 17.3274 19.0006 17.346 18.9729 17.3768C18.9592 17.392 18.9485 17.4098 18.9417 17.4291C18.9348 17.4484 18.9318 17.4689 18.9329 17.4894C18.934 17.5099 18.9391 17.53 18.9479 17.5485C18.9568 17.567 18.9692 17.5836 18.9845 17.5972L20.3228 18.8019C20.338 18.8157 20.3558 18.8263 20.3751 18.8332C20.3944 18.84 20.4149 18.843 20.4354 18.8419C20.4559 18.8409 20.476 18.8358 20.4945 18.8269C20.513 18.8181 20.5296 18.8056 20.5433 18.7904C20.557 18.7752 20.5676 18.7574 20.5745 18.7381C20.5814 18.7187 20.5843 18.6982 20.5833 18.6777C20.5822 18.6573 20.5771 18.6372 20.5682 18.6187C20.5594 18.6002 20.547 18.5836 20.5317 18.5699L19.1934 17.3652C19.1782 17.3514 19.1604 17.3408 19.1411 17.3339C19.1218 17.3271 19.1013 17.3241 19.0808 17.3252H19.0808ZM8.18669 18.4688C8.16113 18.4678 8.13574 18.4732 8.11275 18.4844C8.08977 18.4956 8.0699 18.5123 8.05492 18.533L6.99568 19.9891C6.98357 20.0057 6.97485 20.0244 6.97002 20.0444C6.9652 20.0643 6.96435 20.085 6.96755 20.1053C6.97074 20.1255 6.9779 20.145 6.98862 20.1625C6.99934 20.1799 7.01341 20.1951 7.03002 20.2072C7.04658 20.2193 7.06536 20.228 7.0853 20.2328C7.10523 20.2376 7.12593 20.2385 7.14619 20.2353C7.16645 20.2321 7.18588 20.2249 7.20337 20.2142C7.22086 20.2035 7.23605 20.1894 7.24809 20.1728L8.30737 18.7167C8.31948 18.7002 8.32819 18.6814 8.33302 18.6614C8.33785 18.6415 8.33869 18.6208 8.3355 18.6005C8.33231 18.5803 8.32515 18.5609 8.31443 18.5434C8.30371 18.5259 8.28964 18.5107 8.27303 18.4986C8.24789 18.4803 8.21781 18.4698 8.18669 18.4688ZM17.8055 18.4753C17.7744 18.4764 17.7443 18.4867 17.7191 18.5051C17.7025 18.5171 17.6884 18.5322 17.6776 18.5497C17.6669 18.5672 17.6597 18.5866 17.6565 18.6069C17.6532 18.6271 17.6541 18.6478 17.6589 18.6677C17.6636 18.6877 17.6723 18.7065 17.6844 18.7231L18.7417 20.1806C18.7537 20.1972 18.7689 20.2113 18.7863 20.2221C18.8038 20.2328 18.8232 20.24 18.8435 20.2432C18.8637 20.2465 18.8844 20.2457 18.9044 20.2409C18.9243 20.2361 18.9431 20.2274 18.9597 20.2153C18.9764 20.2033 18.9904 20.1881 19.0012 20.1706C19.012 20.1532 19.0191 20.1337 19.0224 20.1135C19.0256 20.0932 19.0248 20.0725 19.02 20.0526C19.0152 20.0326 19.0065 20.0138 18.9944 19.9973L17.9371 18.5397C17.9222 18.519 17.9023 18.5023 17.8794 18.491C17.8564 18.4798 17.831 18.4744 17.8055 18.4753H17.8055ZM6.81929 18.7002C6.77791 18.7024 6.7391 18.7209 6.7114 18.7518L6.20461 19.3147C6.19085 19.3299 6.18023 19.3477 6.17336 19.367C6.1665 19.3864 6.16351 19.4069 6.16458 19.4273C6.16565 19.4478 6.17076 19.4679 6.17961 19.4864C6.18846 19.5049 6.20087 19.5215 6.21614 19.5352C6.23136 19.5489 6.24914 19.5596 6.26847 19.5664C6.2878 19.5733 6.3083 19.5763 6.32878 19.5752C6.34926 19.5741 6.36933 19.569 6.38783 19.5601C6.40633 19.5513 6.4229 19.5389 6.43659 19.5236L6.94346 18.9608C6.95721 18.9455 6.96783 18.9277 6.9747 18.9084C6.98156 18.8891 6.98455 18.8686 6.98347 18.8481C6.9824 18.8276 6.97728 18.8075 6.96843 18.789C6.95958 18.7705 6.94716 18.7539 6.93189 18.7402C6.91668 18.7265 6.89891 18.7158 6.87958 18.709C6.86026 18.7021 6.83977 18.6991 6.81929 18.7002V18.7002ZM19.1806 18.7009C19.1602 18.6998 19.1397 18.7028 19.1204 18.7096C19.101 18.7165 19.0833 18.7271 19.0681 18.7409C19.0528 18.7546 19.0404 18.7712 19.0315 18.7897C19.0227 18.8082 19.0176 18.8283 19.0165 18.8487C19.0154 18.8692 19.0184 18.8897 19.0253 18.9091C19.0321 18.9284 19.0427 18.9462 19.0565 18.9614L19.5632 19.5244C19.5769 19.5396 19.5935 19.5521 19.612 19.5609C19.6305 19.5698 19.6505 19.5749 19.671 19.576C19.6915 19.577 19.712 19.574 19.7313 19.5672C19.7507 19.5603 19.7684 19.5497 19.7836 19.5359C19.7989 19.5222 19.8113 19.5057 19.8202 19.4872C19.8291 19.4686 19.8342 19.4486 19.8352 19.4281C19.8363 19.4076 19.8333 19.3871 19.8265 19.3678C19.8196 19.3484 19.809 19.3306 19.7952 19.3154L19.2885 18.7525C19.2748 18.7372 19.2582 18.7248 19.2397 18.7159C19.2212 18.7071 19.2011 18.7019 19.1806 18.7009L19.1806 18.7009ZM9.6659 19.3253C9.63521 19.3246 9.60501 19.3331 9.57911 19.3495C9.55321 19.366 9.53277 19.3898 9.52037 19.4179L8.78672 21.0623C8.77833 21.081 8.77371 21.1012 8.77314 21.1217C8.77257 21.1422 8.77606 21.1626 8.7834 21.1818C8.79074 21.2009 8.80179 21.2185 8.81591 21.2333C8.83004 21.2482 8.84696 21.2601 8.86571 21.2685C8.88443 21.2769 8.90462 21.2815 8.92512 21.282C8.94563 21.2826 8.96604 21.2791 8.9852 21.2718C9.00436 21.2645 9.02188 21.2534 9.03675 21.2393C9.05163 21.2252 9.06356 21.2082 9.07188 21.1895L9.8055 19.5451C9.8139 19.5264 9.81851 19.5062 9.81909 19.4857C9.81966 19.4652 9.81618 19.4448 9.80884 19.4256C9.8015 19.4064 9.79044 19.3889 9.77631 19.3741C9.76219 19.3592 9.74526 19.3472 9.7265 19.3389C9.70742 19.3304 9.68681 19.3257 9.6659 19.3253ZM16.3251 19.3298C16.3042 19.3302 16.2836 19.3348 16.2645 19.3434C16.2457 19.3517 16.2288 19.3636 16.2146 19.3784C16.2005 19.3933 16.1894 19.4108 16.182 19.4299C16.1747 19.4491 16.1711 19.4695 16.1717 19.49C16.1722 19.5105 16.1768 19.5307 16.1852 19.5494L16.9166 21.1948C16.9249 21.2136 16.9368 21.2305 16.9516 21.2447C16.9665 21.2588 16.984 21.2699 17.0032 21.2772C17.0223 21.2846 17.0427 21.2881 17.0632 21.2876C17.0837 21.287 17.1039 21.2824 17.1227 21.2741C17.1414 21.2658 17.1583 21.2538 17.1725 21.239C17.1866 21.2241 17.1977 21.2066 17.205 21.1875C17.2124 21.1684 17.2159 21.1479 17.2154 21.1274C17.2148 21.1069 17.2102 21.0868 17.2019 21.068L16.4705 19.4226C16.4581 19.3946 16.4377 19.3708 16.4118 19.3543C16.3859 19.3378 16.3558 19.3293 16.3251 19.3298ZM8.37676 19.8337C8.35124 19.8355 8.32655 19.8435 8.30488 19.8571C8.2832 19.8706 8.26522 19.8894 8.25252 19.9116L7.87382 20.5675C7.86352 20.5852 7.85683 20.6048 7.85413 20.6252C7.85143 20.6455 7.85277 20.6662 7.85808 20.686C7.86338 20.7058 7.87255 20.7244 7.88506 20.7406C7.89756 20.7569 7.91315 20.7705 7.93094 20.7808C7.94868 20.7911 7.96828 20.7977 7.98861 20.8004C8.00894 20.8032 8.02961 20.8018 8.04943 20.7965C8.06924 20.7912 8.08781 20.782 8.10407 20.7695C8.12034 20.757 8.13397 20.7414 8.14419 20.7236L8.52292 20.0676C8.53321 20.0499 8.5399 20.0303 8.5426 20.01C8.5453 19.9896 8.54396 19.969 8.53865 19.9492C8.53334 19.9293 8.52417 19.9108 8.51166 19.8945C8.49915 19.8782 8.48356 19.8646 8.46577 19.8544C8.43883 19.8388 8.40783 19.8316 8.37676 19.8337ZM17.6241 19.8337C17.5931 19.8315 17.5621 19.8387 17.5352 19.8544C17.5174 19.8647 17.5018 19.8783 17.4893 19.8945C17.4768 19.9108 17.4676 19.9294 17.4623 19.9492C17.457 19.969 17.4557 19.9897 17.4584 20.01C17.4611 20.0303 17.4678 20.0499 17.4781 20.0677L17.8568 20.7236C17.867 20.7414 17.8806 20.757 17.8969 20.7695C17.9131 20.782 17.9317 20.7912 17.9515 20.7965C17.9713 20.8018 17.992 20.8032 18.0123 20.8004C18.0327 20.7977 18.0523 20.7911 18.07 20.7808C18.0878 20.7705 18.1034 20.7569 18.1159 20.7406C18.1284 20.7244 18.1376 20.7058 18.1429 20.686C18.1482 20.6662 18.1495 20.6455 18.1468 20.6252C18.1441 20.6048 18.1374 20.5852 18.1271 20.5675L17.7484 19.9116C17.7357 19.8894 17.7177 19.8707 17.696 19.8571C17.6743 19.8435 17.6496 19.8355 17.6241 19.8337ZM11.2991 19.8573C11.2631 19.8569 11.2282 19.8691 11.2002 19.8916C11.1722 19.9142 11.1529 19.9457 11.1455 19.9809L10.7713 21.7423C10.767 21.7624 10.7667 21.7831 10.7704 21.8033C10.7741 21.8234 10.7818 21.8427 10.793 21.8599C10.8041 21.8771 10.8186 21.8919 10.8355 21.9035C10.8524 21.9151 10.8715 21.9232 10.8916 21.9275C10.9116 21.9318 10.9323 21.9321 10.9525 21.9284C10.9727 21.9246 10.9919 21.917 11.0091 21.9058C11.0263 21.8946 11.0412 21.8802 11.0528 21.8632C11.0644 21.8463 11.0725 21.8273 11.0767 21.8072L11.4509 20.0458C11.4558 20.0232 11.4556 19.9997 11.4502 19.9771C11.4448 19.9546 11.4345 19.9335 11.4199 19.9154C11.4054 19.8974 11.387 19.8828 11.3661 19.8727C11.3452 19.8627 11.3223 19.8574 11.2991 19.8574V19.8573ZM14.6963 19.8584C14.6731 19.8584 14.6502 19.8637 14.6293 19.8737C14.6084 19.8837 14.59 19.8983 14.5755 19.9164C14.5609 19.9344 14.5506 19.9555 14.5452 19.978C14.5399 20.0006 14.5396 20.024 14.5444 20.0467L14.9173 21.8083C14.9215 21.8284 14.9296 21.8475 14.9412 21.8644C14.9528 21.8813 14.9676 21.8958 14.9848 21.907C15.002 21.9182 15.0213 21.9259 15.0414 21.9296C15.0616 21.9333 15.0823 21.933 15.1024 21.9287C15.1225 21.9245 15.1415 21.9164 15.1584 21.9048C15.1754 21.8933 15.1898 21.8784 15.201 21.8612C15.2122 21.844 15.2199 21.8248 15.2236 21.8046C15.2274 21.7845 15.2271 21.7637 15.2228 21.7437L14.8498 19.9822C14.8425 19.947 14.8231 19.9154 14.7952 19.8928C14.7672 19.8702 14.7322 19.858 14.6963 19.8583V19.8584ZM13.0004 20.036C12.9799 20.036 12.9596 20.04 12.9406 20.0478C12.9217 20.0556 12.9044 20.0671 12.8899 20.0816C12.8754 20.0962 12.8639 20.1134 12.8561 20.1324C12.8483 20.1513 12.8443 20.1716 12.8443 20.1922V21.9928C12.8443 22.0133 12.8483 22.0336 12.8561 22.0526C12.8639 22.0715 12.8754 22.0888 12.89 22.1033C12.9045 22.1178 12.9217 22.1293 12.9407 22.1371C12.9596 22.1449 12.98 22.1489 13.0005 22.1489C13.021 22.1489 13.0413 22.1449 13.0603 22.1371C13.0792 22.1293 13.0964 22.1178 13.1109 22.1032C13.1254 22.0887 13.1369 22.0715 13.1448 22.0526C13.1526 22.0336 13.1566 22.0133 13.1565 21.9928V20.1922C13.1566 20.1717 13.1526 20.1514 13.1447 20.1324C13.1369 20.1134 13.1254 20.0962 13.1109 20.0817C13.0964 20.0672 13.0792 20.0557 13.0602 20.0478C13.0413 20.04 13.0209 20.036 13.0004 20.0361V20.036ZM10.1349 20.6179C10.1043 20.6205 10.0752 20.6321 10.0511 20.6512C10.0271 20.6703 10.0092 20.6961 9.9998 20.7253L9.76567 21.4456C9.75928 21.4651 9.7568 21.4857 9.75839 21.5061C9.75997 21.5266 9.76558 21.5465 9.77489 21.5648C9.7842 21.5831 9.79703 21.5994 9.81265 21.6127C9.82826 21.626 9.84635 21.6361 9.86588 21.6424C9.88537 21.6487 9.90594 21.6512 9.92639 21.6496C9.94684 21.648 9.96677 21.6424 9.98505 21.6331C10.0033 21.6238 10.0196 21.611 10.0329 21.5953C10.0462 21.5797 10.0563 21.5616 10.0626 21.5421L10.2967 20.8218C10.3031 20.8023 10.3056 20.7818 10.304 20.7613C10.3024 20.7409 10.2968 20.7209 10.2875 20.7027C10.2782 20.6844 10.2654 20.6681 10.2498 20.6548C10.2341 20.6415 10.2161 20.6314 10.1965 20.6251C10.1767 20.6186 10.1557 20.6162 10.1349 20.6179ZM15.8648 20.6183C15.844 20.6164 15.823 20.6188 15.8031 20.6254C15.7836 20.6317 15.7655 20.6418 15.7499 20.6551C15.7343 20.6684 15.7215 20.6847 15.7121 20.7029C15.7028 20.7212 15.6972 20.7412 15.6956 20.7616C15.694 20.7821 15.6965 20.8026 15.7029 20.8221L15.9369 21.5425C15.9432 21.562 15.9533 21.5801 15.9666 21.5957C15.9799 21.6113 15.9962 21.6242 16.0145 21.6335C16.0327 21.6428 16.0527 21.6484 16.0731 21.65C16.0936 21.6516 16.1142 21.6491 16.1337 21.6427C16.1532 21.6364 16.1713 21.6263 16.1869 21.613C16.2025 21.5997 16.2153 21.5835 16.2247 21.5652C16.234 21.5469 16.2396 21.527 16.2412 21.5065C16.2428 21.4861 16.2403 21.4655 16.2339 21.446L15.9998 20.7256C15.9904 20.6964 15.9725 20.6707 15.9485 20.6516C15.9245 20.6325 15.8954 20.6209 15.8648 20.6183H15.8648ZM12.0206 21.0195C11.9848 21.0229 11.9513 21.0387 11.9258 21.064C11.9003 21.0894 11.8843 21.1228 11.8806 21.1585L11.8014 21.9118C11.7993 21.9322 11.8011 21.9529 11.8069 21.9725C11.8127 21.9922 11.8224 22.0105 11.8353 22.0265C11.8482 22.0424 11.8641 22.0556 11.8821 22.0654C11.9002 22.0752 11.92 22.0813 11.9404 22.0834C11.9608 22.0856 11.9814 22.0837 12.0011 22.0779C12.0208 22.0721 12.0391 22.0625 12.055 22.0496C12.071 22.0366 12.0842 22.0207 12.094 22.0027C12.1038 21.9846 12.1099 21.9648 12.112 21.9444L12.1912 21.1912C12.1933 21.1708 12.1915 21.1502 12.1857 21.1305C12.1799 21.1108 12.1703 21.0925 12.1573 21.0765C12.1444 21.0606 12.1285 21.0473 12.1105 21.0376C12.0924 21.0278 12.0726 21.0217 12.0522 21.0196C12.0417 21.0185 12.0311 21.0185 12.0206 21.0195ZM13.9741 21.0202C13.9635 21.0191 13.9529 21.0191 13.9423 21.0203C13.9219 21.0224 13.9021 21.0285 13.8841 21.0383C13.866 21.048 13.8501 21.0612 13.8372 21.0772C13.8243 21.0931 13.8146 21.1114 13.8088 21.1311C13.803 21.1508 13.8011 21.1714 13.8033 21.1918L13.882 21.9452C13.884 21.9656 13.8901 21.9854 13.8999 22.0034C13.9096 22.0215 13.9229 22.0374 13.9388 22.0503C13.9547 22.0632 13.9731 22.0729 13.9927 22.0787C14.0124 22.0845 14.033 22.0864 14.0534 22.0842C14.0738 22.0821 14.0936 22.076 14.1117 22.0662C14.1297 22.0565 14.1457 22.0433 14.1586 22.0273C14.1715 22.0114 14.1811 21.9931 14.187 21.9734C14.1928 21.9537 14.1947 21.9331 14.1925 21.9127L14.1139 21.1594C14.1102 21.1236 14.0943 21.0902 14.0688 21.0648C14.0433 21.0395 14.0098 21.0237 13.974 21.0202H13.9741Z"
          fill="#F4F2F3"
        />
        <g opacity="0.409" filter="url(#filter0_f_11781_19835)">
          <path
            d="M20.316 5.75562L11.7751 10.7179L6.375 19.2192L14.275 13.3678L20.316 5.75562Z"
            fill="black"
          />
        </g>
        <path
          d="M14.2235 13.2816L11.7754 10.7179L20.4597 4.87598L14.2235 13.2816Z"
          fill="#FF5150"
        />
        <path d="M14.2253 13.2817L11.7772 10.718L5.54102 19.1237L14.2253 13.2817Z" fill="#F1F1F1" />
        <path
          opacity="0.243"
          d="M5.54102 19.1236L14.2253 13.2816L20.4616 4.87598L5.54102 19.1236Z"
          fill="black"
        />
        <defs>
          <filter
            id="filter0_f_11781_19835"
            x="0.915988"
            y="0.296604"
            width="24.8594"
            height="24.3816"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="2.72951" result="effect1_foregroundBlur_11781_19835" />
          </filter>
          <linearGradient
            id="paint0_linear_11781_19835"
            x1="13"
            y1="23.6172"
            x2="13"
            y2="0.382263"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#BDBDBD" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <radialGradient
            id="paint1_radial_11781_19835"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(13.0484 10.4387) scale(11.6175 11.6175)"
          >
            <stop stopColor="#06C2E7" />
            <stop offset="0.25" stopColor="#0DB8EC" />
            <stop offset="0.5" stopColor="#12AEF1" />
            <stop offset="0.75" stopColor="#1F86F9" />
            <stop offset="1" stopColor="#107DDD" />
          </radialGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
}
